/* Hannah - AI concierge for Shopify (ElevenLabs Agents + the store's own data).
 * One runtime for the Stage (face-to-face / chat pages) and the Compact widget.
 *
 *   ElevenLabs agent  <-- client tools -->  this file  <-- /products/*.js, ?view=hannah, /cart/add.js -->  Shopify
 *
 * The agent never invents a product: every product she names comes back from a tool
 * call that reads the live store, and every recommendation is painted on screen,
 * remembered in the visitor's browser, and logged to the data webhook.
 */
(function () {
  'use strict';
  if (window.Hannah && window.Hannah.__v) { return; }
  var CFG = window.HannahConfig || {};
  var H = window.Hannah = { __v: '1.0.0' };
  var DEBUG = !!CFG.debug;
  function log() { if (DEBUG && window.console) { console.log.apply(console, ['[Hannah]'].concat([].slice.call(arguments))); } }

  /* ============================================================ utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) { Object.keys(attrs).forEach(function (k) {
      if (k === 'class') { n.className = attrs[k]; }
      else if (k === 'html') { n.innerHTML = attrs[k]; }
      else if (k === 'text') { n.textContent = attrs[k]; }
      else if (k.indexOf('on') === 0) { n.addEventListener(k.slice(2), attrs[k]); }
      else if (attrs[k] != null && attrs[k] !== false) { n.setAttribute(k, attrs[k] === true ? '' : attrs[k]); }
    }); }
    (children || []).forEach(function (c) { if (c == null) { return; } n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  function now() { return new Date().toISOString(); }
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function isPhone() { return window.innerWidth <= 640; }
  function stripHtml(s) { var d = document.createElement('div'); d.innerHTML = s || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function money(cents) {
    if (cents == null || cents === '') { return ''; }
    var fmt = stripHtml(CFG.moneyFormat || '${{amount}}');
    var v = Number(cents) / 100;
    function sep(n, dec, t, d) { var s = n.toFixed(dec); var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return parts.join(d); }
    var out;
    if (/amount_no_decimals_with_comma_separator/.test(fmt)) { out = sep(v, 0, '.', ','); }
    else if (/amount_with_comma_separator/.test(fmt)) { out = sep(v, 2, '.', ','); }
    else if (/amount_no_decimals/.test(fmt)) { out = sep(v, 0, ',', '.'); }
    else if (/amount_with_apostrophe_separator/.test(fmt)) { out = sep(v, 2, "'", '.'); }
    else { out = sep(v, 2, ',', '.'); }
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, out);
  }
  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, opts || {})).then(function (r) {
      if (!r.ok) { throw new Error('HTTP ' + r.status + ' ' + url); }
      return r.text().then(function (t) { try { return JSON.parse(t); } catch (e) { throw new Error('Bad JSON from ' + url); } });
    });
  }
  function icon(name) {
    var P = {
      mic: '<path d="M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3z"/><path d="M19 11a7 7 0 0 1-14 0M12 18v3"/>',
      micOff: '<path d="M3 3l18 18M9 9v3a3 3 0 0 0 5.1 2.1M15 10V6a3 3 0 0 0-5.6-1.5"/><path d="M19 11a7 7 0 0 1-1.6 4.4M5 11a7 7 0 0 0 7 7 6.9 6.9 0 0 0 2.9-.6M12 18v3"/>',
      send: '<path d="M4 12 20 4l-4 16-4-7-8-1z"/>',
      close: '<path d="M6 6l12 12M18 6 6 18"/>',
      eye: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
      eyeOff: '<path d="M3 3l18 18M10.6 10.6a3 3 0 0 0 4.2 4.2M9.9 5.2A10.9 10.9 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3 3.9M6.6 6.6A16.8 16.8 0 0 0 2 12s3.5 7 10 7a9.9 9.9 0 0 0 4.4-1"/>',
      clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
      expand: '<path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7"/>',
      cc: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M10 10a2 2 0 1 0 0 4M16 10a2 2 0 1 0 0 4"/>',
      list: '<path d="M4 6h16M4 12h16M4 18h10"/>',
      phone: '<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/>',
      phoneOff: '<path d="M3 3l18 18M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/>',
      keyboard: '<rect x="3" y="6" width="18" height="12" rx="2"/><path d="M7 10h.01M11 10h.01M15 10h.01M7 14h10"/>',
      cart: '<path d="M3 4h2l2.5 11h11L21 7H7"/><circle cx="9" cy="19" r="1.4"/><circle cx="17" cy="19" r="1.4"/>',
      spark: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/>',
      trash: '<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/>'
    };
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (P[name] || '') + '</svg>';
  }
  var toastEl = null;
  function toast(html, ms) {
    if (toastEl) { toastEl.remove(); }
    toastEl = el('div', { class: 'hannah-toast hannah', html: html });
    document.body.appendChild(toastEl);
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { if (toastEl) { toastEl.remove(); toastEl = null; } }, ms || 4500);
  }
  H.util = { money: money, esc: esc, el: el, toast: toast };

  /* ============================================================ guard (saves minutes and tokens)
     When Hannah hangs up because someone kept asking unrelated or personal things (or was
     abusive), this browser is blocked from starting her again for a while. Each repeat
     within a day doubles the wait. Settings come from the Stage section (CFG.guard). */
  var GUARD_KEY = 'hannah.guard.v1';
  var Guard = {
    opts: function () { var g = CFG.guard || {}; return { blockMin: g.blockMinutes != null ? g.blockMinutes : 15, idle: g.idleSeconds != null ? g.idleSeconds : 20, maxMin: g.maxMinutes != null ? g.maxMinutes : 10, msg: g.blockedMessage || 'Hannah is only here for questions about cigars and the store. Please come back later.' }; },
    load: function () { try { return JSON.parse(localStorage.getItem(GUARD_KEY) || '{}') || {}; } catch (e) { return {}; } },
    save: function (d) { try { localStorage.setItem(GUARD_KEY, JSON.stringify(d)); } catch (e) {} },
    strikes: function () { var d = this.load(); return d.last && Date.now() - d.last < 864e5 ? (d.count || 0) : 0; },
    block: function (reason) {
      var o = this.opts(); if (!o.blockMin) { return; }
      var d = this.load(), now = Date.now();
      var count = d.last && now - d.last < 864e5 ? (d.count || 0) + 1 : 1;
      var mins = Math.min(o.blockMin * Math.pow(2, count - 1) * (reason === 'abuse' ? 4 : 1), 1440);
      this.save({ until: now + mins * 6e4, count: count, last: now, reason: reason });
      $$('.hannah .h-dot').forEach(function (d) { d.classList.add('is-blocked'); });
      Log.event('visitor_blocked', { reason: reason, minutes: mins, strikes: count });
    },
    left: function () { var d = this.load(); return d.until && d.until > Date.now() ? Math.ceil((d.until - Date.now()) / 6e4) : 0; },
    check: function () {
      var m = this.left(); if (!m) { return true; }
      toast(esc(this.opts().msg) + ' <small>(' + m + ' min)</small>', 6000);
      Log.event('blocked_attempt', { minutes_left: m });
      return false;
    }
  };
  H.guard = Guard;

  /* Ends a voice call on silence (no one talks for N seconds) or when it runs too long.
     First asks Hannah to say goodbye, then hangs up for sure a few seconds later. */
  function Watchdog(getSession, onNote) {
    var timer = null, last = 0, started = 0, nudged = 0, capped = 0;
    function now() { return Date.now(); }
    function tick() {
      var s = getSession(); if (!s || !s.isOpen()) { return; }
      var o = Guard.opts(), t = now();
      if (s.mode() === 'speaking' && !nudged) { last = t; }
      if (o.maxMin && !capped && t - started > o.maxMin * 6e4) {
        capped = t; Log.event('call_time_limit', { minutes: o.maxMin });
        s.context('The call has reached its time limit. Thank the customer in one short line, say goodbye, and call hang_up with reason time_limit.');
      }
      if (capped && t - capped > 15000) { stop(); onNote && onNote('time'); s.end('time_limit'); return; }
      if (!o.idle) { return; }
      var quiet = t - last, lead = Math.min(6000, o.idle * 400);
      if (!nudged && quiet > o.idle * 1000 - lead) {
        nudged = t; Log.event('silence_nudge', { seconds: o.idle });
        s.context('The customer has said nothing for a while. Say "I\'ll let you go - come back anytime." and call hang_up with reason silence right now.');
      }
      if (nudged && quiet > o.idle * 1000 && (s.mode() !== 'speaking' || quiet > o.idle * 1000 + 4000)) { stop(); onNote && onNote('silence'); s.end('silence'); }
    }
    function stop() { clearInterval(timer); timer = null; }
    return {
      start: function () { stop(); started = last = now(); nudged = capped = 0; timer = setInterval(tick, 1000); },
      activity: function () { last = now(); nudged = 0; },
      stop: stop
    };
  }

  /* ============================================================ memory (visitor's browser) */
  var MEM_KEY = 'hannah.memory.v1';
  var Memory = {
    data: null,
    fresh: function () { return { sessionId: uid(), createdAt: now(), lastActiveAt: now(), visits: 1, conversations: [], transcript: [], picks: [], notes: {}, prefs: {} }; },
    load: function () {
      if (this.data) { return this.data; }
      var d = null;
      try { d = JSON.parse(localStorage.getItem(MEM_KEY) || 'null'); } catch (e) { d = null; }
      var days = num(CFG.memoryDays, 30);
      if (!d || !d.sessionId || (Date.now() - Date.parse(d.lastActiveAt || 0)) > days * 864e5) { d = this.fresh(); }
      else if ((Date.now() - Date.parse(d.lastActiveAt || 0)) > 30 * 60e3) { d.visits = (d.visits || 1) + 1; }
      d.lastActiveAt = now();
      this.data = d; this.save(); return d;
    },
    save: function () { try { localStorage.setItem(MEM_KEY, JSON.stringify(this.data)); } catch (e) { /* private mode */ } },
    touch: function () { this.load().lastActiveAt = now(); this.save(); },
    picks: function () { return this.load().picks.slice().reverse(); },
    addPick: function (p, reason, convId) {
      var d = this.load();
      d.picks = d.picks.filter(function (x) { return x.handle !== p.handle; });
      d.picks.push({ handle: p.handle, id: p.id, title: p.title, vendor: p.vendor, price: p.price, image: p.thumb || p.image, url: p.url, variantId: p.first_variant_id, variantCount: p.variant_count, reason: reason || '', ts: now(), convId: convId || null });
      if (d.picks.length > 60) { d.picks = d.picks.slice(-60); }
      this.save();
    },
    addMsg: function (role, text, convId, mode) {
      var d = this.load();
      d.transcript.push({ r: role, t: String(text).slice(0, 600), ts: now(), c: convId || null, m: mode || '' });
      if (d.transcript.length > 300) { d.transcript = d.transcript.slice(-300); }
      this.save();
    },
    recent: function (n) { return this.load().transcript.slice(-(n || 10)); },
    setNote: function (k, v) { var d = this.load(); d.notes[String(k).slice(0, 40)] = String(v).slice(0, 300); this.save(); },
    newConversation: function (id, mode, url) { var d = this.load(); d.conversations.push({ id: id, mode: mode, url: url, startedAt: now() }); if (d.conversations.length > 50) { d.conversations = d.conversations.slice(-50); } this.save(); },
    endConversation: function (id) { var d = this.load(); d.conversations.forEach(function (c) { if (c.id === id) { c.endedAt = now(); } }); this.save(); },
    clear: function () { this.data = this.fresh(); this.save(); },
    pref: function (k, v) { var d = this.load(); if (v === undefined) { return d.prefs[k]; } d.prefs[k] = v; this.save(); }
  };
  H.memory = Memory;

  /* ============================================================ data webhook */
  var Log = {
    q: [], t: null,
    event: function (name, data) {
      var d = Memory.load();
      var ev = { event: name, ts: now(), sessionId: d.sessionId, visits: d.visits, customerId: CFG.customer && CFG.customer.id, page: location.pathname, pageType: CFG.page && CFG.page.type, data: data || {} };
      log('event', ev);
      if (!CFG.webhookUrl) { return; }
      if (name === 'message' && CFG.logTranscripts === false) { ev.data = { role: data.role, chars: (data.text || '').length, convId: data.convId }; }
      this.q.push(ev);
      clearTimeout(this.t);
      this.t = setTimeout(function () { Log.flush(); }, 1500);
    },
    flush: function (beacon) {
      if (!this.q.length || !CFG.webhookUrl) { return; }
      var body = JSON.stringify({ shop: CFG.shopName, batch: this.q.splice(0, this.q.length) });
      try {
        if (beacon && navigator.sendBeacon) { navigator.sendBeacon(CFG.webhookUrl, new Blob([body], { type: 'text/plain' })); return; }
        fetch(CFG.webhookUrl, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body }).catch(function () {});
      } catch (e) { /* never break the page over analytics */ }
    }
  };
  window.addEventListener('pagehide', function () { Log.flush(true); });
  H.log = Log;

  /* ============================================================ catalog (reads the live store) */
  var cache = {};
  var Catalog = {
    product: function (handle) {
      handle = String(handle || '').trim().toLowerCase().replace(/^\/?products\//, '').split('?')[0];
      if (!handle) { return Promise.reject(new Error('no handle')); }
      if (cache['p:' + handle]) { return Promise.resolve(cache['p:' + handle]); }
      return fetchJSON('/products/' + encodeURIComponent(handle) + '?view=hannah').then(function (p) {
        /* only trust it when it really is our view: handle, title and a variant id */
        if (!p || !p.handle || !p.title || !p.first_variant_id) { throw new Error('not the hannah view'); }
        return p;
      }).catch(function () {
        /* the rich view is missing (template not uploaded) - fall back to Shopify's product JSON */
        return fetchJSON('/products/' + encodeURIComponent(handle) + '.js').then(function (p) {
          if (!p || !p.handle || !p.variants) { throw new Error('Product not found: ' + handle); }
          return {
            id: p.id, handle: p.handle, title: p.title, vendor: p.vendor, type: p.type, url: '/products/' + p.handle, available: p.available,
            price: p.price, price_min: p.price_min, price_max: p.price_max, compare_at_price: p.compare_at_price || 0,
            image: p.featured_image, thumb: p.featured_image, first_variant_id: (p.variants.find(function (v) { return v.available; }) || p.variants[0]).id,
            variant_count: p.variants.length, tags: p.tags, specs: {}, description: stripHtml(p.description).slice(0, 1800), images: p.images.slice(0, 4),
            options: p.options.map(function (o) { return { name: o.name, values: o.values }; }),
            variants: p.variants.map(function (v) { return { id: v.id, title: v.title, price: v.price, compare_at_price: v.compare_at_price || 0, available: v.available, sku: v.sku, image: v.featured_image && v.featured_image.src }; }),
            collections: []
          };
        });
      }).then(function (p) { cache['p:' + handle] = p; return p; });
    },
    search: function (q, limit) {
      q = String(q || '').trim(); limit = clamp(num(limit, 8), 1, 20);
      var key = 's:' + q + ':' + limit;
      if (cache[key]) { return Promise.resolve(cache[key]); }
      return fetchJSON((CFG.urls && CFG.urls.search || '/search') + '?view=hannah&type=product&options[prefix]=last&q=' + encodeURIComponent(q)).then(function (r) {
        if (!r || !Array.isArray(r.results)) { throw new Error('not the hannah view'); }
        r.results = r.results.slice(0, limit); cache[key] = r; return r;
      }).catch(function () {
        return fetchJSON((CFG.urls && CFG.urls.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + limit + '&resources[options][unavailable_products]=last').then(function (r) {
          var list = (r.resources && r.resources.results && r.resources.results.products) || [];
          return { query: q, count: list.length, results: list.map(function (p) { return { id: p.id, handle: p.handle, title: p.title, vendor: p.vendor, type: p.type, url: p.url, available: p.available, price: Math.round(parseFloat(p.price) * 100), image: p.featured_image && p.featured_image.url, thumb: p.featured_image && p.featured_image.url, first_variant_id: p.variants && p.variants[0] && p.variants[0].id, variant_count: (p.variants || []).length || 2, specs: {} }; }) };
        });
      });
    },
    collection: function (handle, opts) {
      opts = opts || {};
      handle = String(handle || '').trim().toLowerCase().replace(/^\/?collections\//, '').split('?')[0];
      var qs = '?view=hannah' + (opts.page ? '&page=' + opts.page : '') + (opts.sort ? '&sort_by=' + encodeURIComponent(opts.sort) : '') + (opts.maxPrice ? '&filter.v.price.lte=' + opts.maxPrice : '') + (opts.minPrice ? '&filter.v.price.gte=' + opts.minPrice : '');
      var key = 'c:' + handle + qs;
      if (cache[key]) { return Promise.resolve(cache[key]); }
      return fetchJSON('/collections/' + encodeURIComponent(handle) + qs).then(function (c) {
        if (!c || !Array.isArray(c.products)) { throw new Error('not the hannah view'); }
        return c;
      }).catch(function () {
        return fetchJSON('/collections/' + encodeURIComponent(handle) + '/products.json?limit=24' + (opts.page ? '&page=' + opts.page : '')).then(function (r) {
          return { title: handle, handle: handle, url: '/collections/' + handle, count: (r.products || []).length, products: (r.products || []).map(function (p) {
            var v0 = p.variants[0] || {};
            return { id: p.id, handle: p.handle, title: p.title, vendor: p.vendor, type: p.product_type, url: '/collections/' + handle + '/products/' + p.handle, available: p.variants.some(function (v) { return v.available; }), price: Math.round(parseFloat(v0.price || 0) * 100), image: p.images[0] && p.images[0].src, thumb: p.images[0] && p.images[0].src, first_variant_id: v0.id, variant_count: p.variants.length, specs: {} };
          }) };
        });
      }).then(function (c) { cache[key] = c; return c; });
    },
    related: function (productId, limit) {
      var url = (CFG.urls && CFG.urls.recommendations || '/recommendations/products') + '.json?product_id=' + productId + '&limit=' + clamp(num(limit, 6), 1, 10) + '&intent=related';
      return fetchJSON(url).then(function (r) {
        return (r.products || []).map(function (p) {
          var v0 = p.variants.find(function (v) { return v.available; }) || p.variants[0] || {};
          return { id: p.id, handle: p.handle, title: p.title, vendor: p.vendor, type: p.type, url: p.url, available: p.available, price: p.price, compare_at_price: p.compare_at_price || 0, image: p.featured_image, thumb: p.featured_image, first_variant_id: v0.id, variant_count: p.variants.length, specs: {} };
        });
      }).catch(function () { return []; });
    },
    suggestCollections: function (q) {
      return fetchJSON((CFG.urls && CFG.urls.predictiveSearch || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=collection&resources[limit]=8').then(function (r) {
        return ((r.resources && r.resources.results && r.resources.results.collections) || []).map(function (c) { return { title: c.title, handle: c.handle, url: c.url, image: c.featured_image && c.featured_image.url }; });
      }).catch(function () { return []; });
    },
    cart: function () { return fetchJSON('/cart.js'); },
    add: function (variantId, qty, props, handle) {
      if (!variantId || variantId === 'undefined') {
        if (!handle) { return Promise.reject(new Error('Please open the product to choose an option.')); }
        return Catalog.product(handle).then(function (f) {
          var v = (f.variants || []).find(function (x) { return x.available; }) || (f.variants || [])[0];
          if (!v) { throw new Error('This product is sold out.'); }
          return Catalog.add(v.id, qty, props);
        });
      }
      var body = { items: [{ id: Number(variantId), quantity: clamp(num(qty, 1), 1, 50), properties: props || { '_hannah': 'recommended' } }] };
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw new Error(j.description || j.message || 'Could not add to cart'); } return j; }); })
        .then(function (j) { Catalog.afterAdd(j); return j; });
    },
    afterAdd: function (j) {
      /* Let the theme (Archetype Motion) open its cart drawer; several event names so it works across versions. */
      var item = j && j.items ? j.items[0] : j;
      try {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: null } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) { /* ignore */ }
      Catalog.cart().then(function (c) {
        $$('.cart-link__bubble-num, [data-cart-count], .js-cart-count, .cart-count').forEach(function (n) { n.textContent = c.item_count; });
        $$('.cart-link__bubble').forEach(function (n) { n.classList.add('cart-link__bubble--visible'); });
        try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } })); } catch (e) {}
        toast('<span>' + icon('cart') + '</span> <span>Added ' + esc(item && item.product_title || '') + '</span> <a href="' + esc(CFG.urls && CFG.urls.cart || '/cart') + '">View cart (' + c.item_count + ')</a>');
      }).catch(function () {});
    }
  };
  H.catalog = Catalog;

  /* ============================================================ ElevenLabs SDK loader */
  var sdkPromise = null;
  function loadSDK() {
    if (window.ElevenLabsClient && window.ElevenLabsClient.Conversation) { return Promise.resolve(window.ElevenLabsClient); }
    if (sdkPromise) { return sdkPromise; }
    sdkPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = CFG.sdkUrl; s.async = true;
      s.onload = function () { if (window.ElevenLabsClient && window.ElevenLabsClient.Conversation) { resolve(window.ElevenLabsClient); } else { reject(new Error('ElevenLabs SDK loaded but Conversation is missing')); } };
      s.onerror = function () { sdkPromise = null; reject(new Error('Could not load the ElevenLabs SDK from ' + CFG.sdkUrl)); };
      document.head.appendChild(s);
    });
    return sdkPromise;
  }

  /* ============================================================ product/collection cards */
  function specChips(p) {
    var s = p.specs || {}; var out = [];
    var S = ['', 'Mild', 'Mild-Medium', 'Medium', 'Medium-Full', 'Full'];
    if (s.strength) { out.push(['Strength', S[Number(s.strength)] || s.strength]); }
    if (s.wrapper_color) { out.push(['Wrapper', s.wrapper_color]); }
    if (s.shape) { out.push(['Shape', s.shape]); }
    if (s.length || s.ring) { out.push(['Size', [s.length, s.ring].filter(Boolean).join(' x ')]); }
    if (s.made_in) { out.push(['Made in', s.made_in]); }
    if (s.flavor) { out.push(['Notes', String(s.flavor).slice(0, 40)]); }
    return out.slice(0, 5);
  }
  function priceHtml(p) {
    var pr = p.price != null ? p.price : p.price_min;
    var h = '<b>' + esc(money(pr)) + '</b>';
    if (p.price_max && p.price_min != null && p.price_max > p.price_min) { h = '<b>' + esc(money(p.price_min)) + ' - ' + esc(money(p.price_max)) + '</b>'; }
    if (p.compare_at_price && p.compare_at_price > pr) { h += ' <s>' + esc(money(p.compare_at_price)) + '</s>'; }
    return h;
  }
  /* size: 'featured' | 'small' | 'mini' ; opts: { reason, tag, onAdd, newTab, inline } */
  /* words shown on cards; the Stage section overrides them from the theme editor */
  var TXT = {};
  function tx(key, fallback) { return TXT[key] || fallback; }
  function productCard(p, size, opts) {
    opts = opts || {}; size = size || 'small';
    var card = el('div', { class: 'h-card h-card--' + size + (p.available === false ? ' is-sold-out' : ''), 'data-handle': p.handle });
    var link = el('a', { class: 'h-card__media', href: p.url || ('/products/' + p.handle), target: opts.newTab ? '_blank' : null, rel: opts.newTab ? 'noopener' : null, 'aria-label': p.title }, [
      el('img', { src: p.image || p.thumb || '', alt: p.title, loading: 'lazy' })
    ]);
    if (opts.tag) { link.appendChild(el('span', { class: 'h-card__tag', text: opts.tag })); }
    card.appendChild(link);
    var body = el('div', { class: 'h-card__body' });
    if (size !== 'mini' && p.vendor) { body.appendChild(el('div', { class: 'h-card__vendor', text: p.vendor })); }
    body.appendChild(el('a', { class: 'h-card__title', href: p.url || ('/products/' + p.handle), target: opts.newTab ? '_blank' : null, rel: opts.newTab ? 'noopener' : null, text: p.title, style: 'text-decoration:none' }));
    body.appendChild(el('div', { class: 'h-card__price', html: priceHtml(p) }));
    if ((size === 'featured' || size === 'pick') && opts.reason) { body.appendChild(el('p', { class: 'h-card__why', text: '“' + opts.reason + '”' })); }
    if (size === 'featured') {
      var chips = specChips(p);
      if (chips.length) { body.appendChild(el('div', { class: 'h-card__specs' }, chips.map(function (c) { return el('span', { html: esc(c[0]) + ': <b>' + esc(c[1]) + '</b>' }); }))); }
    }
    var actions = el('div', { class: 'h-card__actions' });
    var select = null, qty = null;
    if ((size === 'featured' || size === 'pick') && p.variants && p.variants.length > 1) {
      select = el('select', { 'aria-label': 'Option' }, p.variants.map(function (v) { return el('option', { value: v.id, disabled: !v.available, text: v.title + ' - ' + money(v.price) + (v.available ? '' : ' (sold out)') }); }));
      var firstOk = p.variants.find(function (v) { return v.available; }); if (firstOk) { select.value = firstOk.id; }
      actions.appendChild(select);
      qty = el('input', { class: 'h-qty', type: 'number', min: 1, max: 50, value: 1, 'aria-label': 'Quantity' });
      actions.appendChild(qty);
    }
    var addBtn = el('button', { class: 'h-btn h-btn--solid', type: 'button', html: icon('cart') + '<span>' + esc(p.available === false ? tx('soldOut', 'Sold out') : tx('addToCart', 'Add to cart')) + '</span>', disabled: p.available === false });
    addBtn.addEventListener('click', function () {
      addBtn.disabled = true;
      var vid = select ? select.value : p.first_variant_id;
      var q = qty ? qty.value : 1;
      var go = function (variantId) {
        return Catalog.add(variantId, q, null, p.handle).then(function (j) {
          card.classList.add('is-added');
          addBtn.innerHTML = icon('cart') + '<span>Added</span>';
          Log.event('add_to_cart', { handle: p.handle, title: p.title, variantId: variantId, qty: Number(q), price: p.price, via: 'card' });
          if (opts.onAdd) { opts.onAdd(p, j); }
          setTimeout(function () { addBtn.disabled = false; addBtn.innerHTML = icon('cart') + '<span>Add to cart</span>'; }, 2500);
        }).catch(function (e) { addBtn.disabled = false; toast(esc(e.message)); });
      };
      if (!select && (p.variant_count > 1 || !p.first_variant_id)) {
        /* several options and we only have the short card: load the product and let them choose */
        Catalog.product(p.handle).then(function (full) {
          var ok = full.variants.filter(function (v) { return v.available; });
          if (ok.length === 1) { return go(ok[0].id); }
          var sel = el('select', {}, full.variants.map(function (v) { return el('option', { value: v.id, disabled: !v.available, text: v.title + ' - ' + money(v.price) }); }));
          if (ok[0]) { sel.value = ok[0].id; }
          actions.insertBefore(sel, addBtn);
          select = sel; addBtn.disabled = false;
          addBtn.innerHTML = icon('cart') + '<span>Add this one</span>';
        }).catch(function () { go(vid); });
        return;
      }
      go(vid);
    });
    actions.appendChild(addBtn);
    if (size === 'featured' || size === 'pick') { actions.appendChild(el('a', { class: 'h-btn h-btn--ghost', href: p.url || ('/products/' + p.handle), target: size === 'pick' ? null : '_blank', rel: 'noopener', text: tx('viewProduct', 'View product') })); }
    body.appendChild(actions);
    card.appendChild(body);
    return card;
  }
  function collectionCard(c) {
    return el('a', { class: 'h-coll', href: c.url || ('/collections/' + c.handle) }, [
      c.image ? el('img', { src: c.image, alt: '', loading: 'lazy' }) : null,
      el('div', { class: 'h-coll__txt' }, [el('b', { text: c.title }), el('span', { text: c.count ? c.count + ' items' : 'Collection' })])
    ]);
  }
  H.productCard = productCard;

  /* ============================================================ starfield background
     Quiet and simple: small twinkling dots and a few fine lines between close
     neighbours, drifting slowly. Colours come from the section's own text and
     accent colours, so it works on white and on dark. */
  function Galaxy(host, o) {
    o = Object.assign({ stars: 120, speed: 1, accent: '#a97c2f', ink: '#1c1d1d', lines: true }, o || {});
    var canvas = el('canvas'); host.appendChild(canvas);
    var ctx = canvas.getContext('2d'), W = 0, Hh = 0, dpr = Math.min(2, window.devicePixelRatio || 1);
    var stars = [], running = true, visible = true, raf = 0, t0 = performance.now(), mouse = { x: .5, y: .5 };
    function rgba(hex, a) {
      var h = String(hex || '#000').trim().replace('#', '');
      if (h.length === 3) { h = h.split('').map(function (c) { return c + c; }).join(''); }
      var n = parseInt(h.slice(0, 6), 16); if (isNaN(n)) { n = 0; }
      return 'rgba(' + (n >> 16 & 255) + ',' + (n >> 8 & 255) + ',' + (n & 255) + ',' + a + ')';
    }
    function size() {
      var r = host.getBoundingClientRect(); W = Math.max(1, r.width); Hh = Math.max(1, r.height);
      canvas.width = W * dpr; canvas.height = Hh * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (!stars.length) { seed(); }
    }
    function seed() {
      stars = [];
      var n = Math.round((isPhone() ? .5 : 1) * o.stars);
      for (var i = 0; i < n; i++) {
        stars.push({ x: Math.random(), y: Math.random(), r: Math.random() * 1.2 + .4, p: Math.random() * 6.28, s: .3 + Math.random() * .7, z: Math.random(),
                     vx: (Math.random() - .5) * .00004, vy: (Math.random() - .5) * .00003, gold: Math.random() < .22 });
      }
    }
    function frame(ts) {
      if (!running) { return; }
      raf = requestAnimationFrame(frame);
      if (!visible || document.hidden) { return; }
      var t = (ts - t0) / 1000;
      ctx.clearRect(0, 0, W, Hh);
      var pts = [];
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        s.x += s.vx * o.speed; s.y += s.vy * o.speed;
        if (s.x < -.02) { s.x = 1.02; } if (s.x > 1.02) { s.x = -.02; }
        if (s.y < -.02) { s.y = 1.02; } if (s.y > 1.02) { s.y = -.02; }
        pts.push([s.x * W + (mouse.x - .5) * 14 * s.z, s.y * Hh + (mouse.y - .5) * 10 * s.z]);
      }
      if (o.lines) {
        var maxD = Math.min(130, Math.max(70, W / 11)), maxD2 = maxD * maxD;
        ctx.lineWidth = .6;
        for (var a = 0; a < pts.length; a++) {
          for (var b = a + 1; b < pts.length; b++) {
            var dx = pts[a][0] - pts[b][0], dy = pts[a][1] - pts[b][1], d2 = dx * dx + dy * dy;
            if (d2 < maxD2) {
              ctx.strokeStyle = rgba(o.accent, (1 - d2 / maxD2) * .22);
              ctx.beginPath(); ctx.moveTo(pts[a][0], pts[a][1]); ctx.lineTo(pts[b][0], pts[b][1]); ctx.stroke();
            }
          }
        }
      }
      for (var j = 0; j < stars.length; j++) {
        var st = stars[j], tw = .45 + .55 * (0.5 + 0.5 * Math.sin(t * st.s * 1.4 + st.p));
        ctx.fillStyle = st.gold ? rgba(o.accent, .55 * tw + .2) : rgba(o.ink, (.18 + st.z * .22) * tw);
        ctx.beginPath(); ctx.arc(pts[j][0], pts[j][1], st.r, 0, 6.283); ctx.fill();
      }
    }
    size();
    var ro = window.ResizeObserver ? new ResizeObserver(size) : null; if (ro) { ro.observe(host); } else { window.addEventListener('resize', size); }
    var io = window.IntersectionObserver ? new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }) : null; if (io) { io.observe(host); }
    (host.parentElement || host).addEventListener('pointermove', function (e) { var r = host.getBoundingClientRect(); mouse.x = (e.clientX - r.left) / r.width; mouse.y = (e.clientY - r.top) / r.height; }, { passive: true });
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) { raf = requestAnimationFrame(frame); } else { running = false; requestAnimationFrame(function (ts) { running = true; frame(ts); running = false; }); }
    return { destroy: function () { running = false; cancelAnimationFrame(raf); if (ro) { ro.disconnect(); } if (io) { io.disconnect(); } canvas.remove(); } };
  }
  function cssVar(root, name, fallback) { try { var v = getComputedStyle(root).getPropertyValue(name).trim(); return v || fallback; } catch (e) { return fallback; } }

  /* ============================================================ waveform */
  function Wave(canvas, getFreq, getLevel, accent) {
    var ctx = canvas.getContext('2d'), raf = 0, running = true, dpr = Math.min(2, window.devicePixelRatio || 1);
    function frame() {
      if (!running) { return; }
      raf = requestAnimationFrame(frame);
      var r = canvas.getBoundingClientRect(); if (!r.width) { return; }
      if (canvas.width !== Math.round(r.width * dpr)) { canvas.width = r.width * dpr; canvas.height = r.height * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
      var W = r.width, Hh = r.height; ctx.clearRect(0, 0, W, Hh);
      var data = getFreq ? getFreq() : null; var level = getLevel ? getLevel() : 0;
      var bars = Math.min(48, Math.max(16, Math.floor(W / 9))); var gap = 3, bw = (W - gap * (bars - 1)) / bars;
      for (var i = 0; i < bars; i++) {
        var v = 0;
        if (data && data.length) { var idx = Math.floor(i / bars * data.length * .6); v = (data[idx] || 0) / 255; }
        else { v = level * (0.4 + 0.6 * Math.abs(Math.sin(i * .7 + performance.now() / 180))); }
        var h = Math.max(3, v * Hh * .95); var x = i * (bw + gap), y = (Hh - h) / 2;
        ctx.fillStyle = accent; ctx.globalAlpha = .35 + v * .65;
        ctx.beginPath(); if (ctx.roundRect) { ctx.roundRect(x, y, bw, h, bw / 2); } else { ctx.rect(x, y, bw, h); } ctx.fill();
      }
      ctx.globalAlpha = 1;
    }
    raf = requestAnimationFrame(frame);
    return { destroy: function () { running = false; cancelAnimationFrame(raf); } };
  }

  /* ============================================================ floating past picks */
  function Bubbles(host, o) {
    o = Object.assign({ max: 10, size: 74, speed: 1, onOpen: null, exclude: null }, o || {});
    var slots = [], W = 0, Hh = 0, raf = 0, running = true, last = 0;
    var label = el('div', { class: 'hannah-bubbles__label', text: o.label || 'From your earlier chats' }); host.appendChild(label); label.hidden = true;
    function measure() { var r = host.getBoundingClientRect(); W = r.width; Hh = r.height; }
    function make(item) {
      var d = (isPhone() ? o.size * .72 : o.size) * (.8 + Math.random() * .45);
      var b = el('button', { class: 'h-bubble is-out', type: 'button', 'aria-label': item.title, html: '<span class="h-bubble__ball"><img alt="" loading="lazy" src="' + esc(item.image || '') + '"></span><span class="h-bubble__tip"><b>' + esc(item.title) + '</b><span>' + esc(money(item.price)) + ' · tap to see again</span></span>' });
      b.style.setProperty('--d', d.toFixed(0) + 'px');
      b.addEventListener('click', function () { if (o.onOpen) { o.onOpen(item); } });
      host.appendChild(b);
      var s = { el: b, d: d, item: item, x: Math.random() * Math.max(1, W - d), y: Math.random() * Math.max(1, Hh - d), vx: (Math.random() - .5) * .5, vy: (Math.random() - .5) * .5 };
      b.style.transform = 'translate3d(' + s.x + 'px,' + s.y + 'px,0)';
      requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.remove('is-out'); }); });
      return s;
    }
    function set(items) {
      measure();
      items = (items || []).filter(function (it) { return !o.exclude || it.handle !== o.exclude; }).slice(0, isPhone() ? Math.min(o.max, 6) : o.max);
      slots.forEach(function (s) { s.el.classList.add('is-out'); setTimeout(function () { s.el.remove(); }, 650); });
      slots = items.map(make);
      label.hidden = !slots.length;
    }
    function tick(ts) {
      if (!running) { return; }
      raf = requestAnimationFrame(tick);
      if (document.hidden || !slots.length) { return; }
      var dt = Math.min(32, ts - last) || 16; last = ts; var k = dt / 16 * o.speed;
      for (var a = 0; a < slots.length; a++) {
        for (var b = a + 1; b < slots.length; b++) {
          var p = slots[a], q = slots[b], pr = p.d / 2, qr = q.d / 2;
          var dx = (q.x + qr) - (p.x + pr), dy = (q.y + qr) - (p.y + pr), min = (pr + qr) * .96, d2 = dx * dx + dy * dy;
          if (d2 > 0 && d2 < min * min) { var dist = Math.sqrt(d2), push = (min - dist) / dist * .2 * k; p.x -= dx * push; p.y -= dy * push; q.x += dx * push; q.y += dy * push; }
        }
      }
      for (var i = 0; i < slots.length; i++) {
        var n = slots[i]; n.x += n.vx * k; n.y += n.vy * k;
        if (n.x < 0) { n.x = 0; n.vx = Math.abs(n.vx); } if (n.y < 0) { n.y = 0; n.vy = Math.abs(n.vy); }
        if (n.x > W - n.d) { n.x = W - n.d; n.vx = -Math.abs(n.vx); } if (n.y > Hh - n.d) { n.y = Hh - n.d; n.vy = -Math.abs(n.vy); }
        n.el.style.transform = 'translate3d(' + n.x.toFixed(1) + 'px,' + n.y.toFixed(1) + 'px,0)';
      }
    }
    var ro = window.ResizeObserver ? new ResizeObserver(function () { var oW = W, oH = Hh; measure(); slots.forEach(function (n) { n.x = clamp(n.x / (oW || 1) * W, 0, Math.max(0, W - n.d)); n.y = clamp(n.y / (oH || 1) * Hh, 0, Math.max(0, Hh - n.d)); }); }) : null;
    if (ro) { ro.observe(host); }
    measure(); raf = requestAnimationFrame(tick);
    return { set: set, destroy: function () { running = false; cancelAnimationFrame(raf); if (ro) { ro.disconnect(); } slots.forEach(function (s) { s.el.remove(); }); } };
  }

  /* ============================================================ transcript */
  function Transcript(host, opts) {
    opts = opts || {};
    var pending = null, lastAgent = null;
    var scroller = opts.scroller || host;
    function scroll() {
      var go = function () { scroller.scrollTop = scroller.scrollHeight; };
      requestAnimationFrame(go); setTimeout(go, 400);
    }
    function add(role, text, extra) {
      extra = extra || {};
      var m = el('div', { class: 'h-msg h-msg--' + role + (extra.pending ? ' h-msg--pending' : '') }, [
        role === 'system' ? null : el('div', { class: 'h-msg__who', text: role === 'user' ? (extra.who || 'You') : (CFG.name || 'Hannah') }),
        el('div', { class: 'h-msg__bubble', text: text || '' })
      ]);
      host.appendChild(m);
      if (host.children.length > 160) { host.removeChild(host.firstChild); }
      if (role === 'agent') { lastAgent = m; }
      scroll();
      return m;
    }
    return {
      el: host,
      add: add,
      user: function (t) { return add('user', t); },
      system: function (t) { return add('system', t); },
      agentStart: function () { if (pending) { return pending; } pending = add('agent', '', { pending: true }); return pending; },
      agentDelta: function (t) { if (!pending) { this.agentStart(); } var b = $('.h-msg__bubble', pending); b.textContent += t; scroll(); },
      agentFinal: function (t) {
        var m = pending; pending = null;
        if (m) { m.classList.remove('h-msg--pending'); $('.h-msg__bubble', m).textContent = t; }
        else { m = add('agent', t); }
        lastAgent = m; scroll(); return m;
      },
      attach: function (node, o) {
        o = o || {};
        /* cards belong to her latest answer; if the customer spoke after it (or she hasn't
           answered yet), start a new card row at the bottom - never up in the history */
        var target = lastAgent;
        if (!target || target !== host.lastElementChild) {
          target = el('div', { class: 'h-msg h-msg--agent h-msg--cards-only' });
          host.appendChild(target); lastAgent = target;
        }
        var cls = 'h-msg__cards' + (o.stack ? ' h-msg__cards--stack' : '');
        var boxes = $$('.h-msg__cards', target), box = boxes[boxes.length - 1];
        if (!box || box.className !== cls) { box = target.appendChild(el('div', { class: cls })); }
        box.appendChild(node); scroll();
        /* pictures load after the card is placed: keep the newest card in view */
        $$('img', node).forEach(function (im) { if (!im.complete) { im.addEventListener('load', scroll, { once: true }); } });
      },
      clear: function () { host.innerHTML = ''; pending = null; lastAgent = null; }
    };
  }

  /* ============================================================ memory sheet (past picks + conversation) */
  function openMemorySheet(onPick) {
    var picks = Memory.picks(), lines = Memory.recent(60);
    var body = el('div', { class: 'hannah-sheet__body' });
    var tabs = el('div', { class: 'hannah-sheet__tabs' });
    var tabPicks = el('button', { type: 'button', class: 'is-on', text: 'Her picks for you (' + picks.length + ')' });
    var tabConv = el('button', { type: 'button', text: 'What we talked about' });
    tabs.appendChild(tabPicks); tabs.appendChild(tabConv);
    var grid = el('div', { class: 'h-grid' });
    if (!picks.length) { grid.appendChild(el('div', { class: 'h-empty', text: 'Nothing yet. Ask ' + (CFG.name || 'Hannah') + ' for a recommendation and it lands here.' })); grid.style.gridTemplateColumns = '1fr'; }
    picks.forEach(function (pk) {
      var card = productCard({ handle: pk.handle, title: pk.title, vendor: pk.vendor, price: pk.price, image: pk.image, url: pk.url, first_variant_id: pk.variantId, variant_count: pk.variantCount || 1, available: true }, 'small', { tag: new Date(pk.ts).toLocaleDateString() });
      card.addEventListener('click', function (e) { if (e.target.closest('button, select, input')) { return; } if (onPick) { e.preventDefault(); onPick(pk); close(); } });
      grid.appendChild(card);
    });
    var conv = el('div', { class: 'hannah-transcript', style: 'max-height:none;width:100%' });
    if (!lines.length) { conv.appendChild(el('div', { class: 'h-empty', text: 'No conversation saved yet.' })); }
    lines.forEach(function (l) { conv.appendChild(el('div', { class: 'h-msg h-msg--' + (l.r === 'user' ? 'user' : 'agent') }, [el('div', { class: 'h-msg__who', text: l.r === 'user' ? 'You' : (CFG.name || 'Hannah') }), el('div', { class: 'h-msg__bubble', text: l.t })])); });
    conv.hidden = true;
    tabPicks.onclick = function () { tabPicks.classList.add('is-on'); tabConv.classList.remove('is-on'); grid.hidden = false; conv.hidden = true; };
    tabConv.onclick = function () { tabConv.classList.add('is-on'); tabPicks.classList.remove('is-on'); grid.hidden = true; conv.hidden = false; };
    body.appendChild(tabs); body.appendChild(grid); body.appendChild(conv);
    var sheet = el('div', { class: 'hannah hannah-sheet', role: 'dialog', 'aria-modal': 'true' });
    var card = el('div', { class: 'hannah-sheet__card', style: 'background:' + (document.querySelector('.hannah') ? getComputedStyle(document.querySelector('.hannah')).getPropertyValue('--h-panel') : '#15100a') }, [
      el('div', { class: 'hannah-sheet__head' }, [el('h3', { text: 'Your memory with ' + (CFG.name || 'Hannah') }), el('button', { class: 'h-btn h-btn--icon', type: 'button', 'aria-label': 'Close', html: icon('close'), onclick: function () { close(); } })]),
      body,
      el('div', { class: 'hannah-sheet__foot' }, [el('span', { text: 'Saved only in this browser for ' + num(CFG.memoryDays, 30) + ' days.' }), el('button', { class: 'h-btn h-btn--ghost', type: 'button', html: icon('trash') + '<span>Forget everything</span>', onclick: function () { if (confirm('Forget all past picks and conversations on this device?')) { Memory.clear(); Log.event('memory_cleared'); close(); document.dispatchEvent(new CustomEvent('hannah:memory')); } } })])
    ]);
    var root = document.querySelector('.hannah'); if (root) { ['--h-bg', '--h-panel', '--h-text', '--h-accent'].forEach(function (v) { sheet.style.setProperty(v, getComputedStyle(root).getPropertyValue(v)); }); }
    sheet.appendChild(card);
    sheet.addEventListener('click', function (e) { if (e.target === sheet) { close(); } });
    function close() { sheet.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') { close(); } }
    document.addEventListener('keydown', onKey);
    document.body.appendChild(sheet);
    Log.event('memory_opened', { picks: picks.length });
  }
  H.openMemory = openMemorySheet;

  /* ============================================================ sign-up (inline newsletter form) */
  function signupCard(onDone) {
    var email = el('input', { type: 'email', required: true, placeholder: 'your@email.com', 'aria-label': 'Email', style: 'flex:1;min-width:0;background:transparent;border:0;outline:0;color:inherit;font:inherit;font-size:14px;padding:8px 0' });
    var btn = el('button', { class: 'h-btn h-btn--solid', type: 'submit', text: tx('signupButton', 'Join') });
    var form = el('form', { class: 'hannah-composer', style: 'margin:0;width:100%', method: 'post', action: '/contact#contact_form' }, [email, btn]);
    var wrap = el('div', { class: 'h-card h-card--featured', style: 'padding:14px 14px 12px;gap:8px' }, [
      el('div', { class: 'h-card__vendor', text: tx('signupTitle', 'Subscriber list') }),
      el('div', { class: 'h-card__title', text: CFG.subscriberOffer ? CFG.subscriberOffer : tx('signupText', 'Join the list for subscriber-only deals.') }),
      form,
      el('a', { href: CFG.urls && CFG.urls.signup, target: '_blank', rel: 'noopener', style: 'font-size:12px;color:var(--h-accent)', text: tx('signupLink', 'Or open the full sign-up page') })
    ]);
    form.addEventListener('submit', function (e) {
      e.preventDefault(); btn.disabled = true;
      var fd = new FormData();
      fd.append('form_type', 'customer'); fd.append('utf8', '✓'); fd.append('contact[email]', email.value); fd.append('contact[tags]', 'newsletter,hannah');
      fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'follow' }).then(function (r) {
        if (/challenge/.test(r.url || '')) { window.open((CFG.urls && CFG.urls.signup) || '/pages/sign-up', '_blank'); throw new Error('challenge'); }
        wrap.innerHTML = '<div class="h-card__title">You’re on the list. Welcome.</div><p class="h-card__why">Check your inbox for the first-order code.</p>';
        Log.event('signup_submit', { ok: true });
        if (onDone) { onDone(true); }
      }).catch(function (err) { btn.disabled = false; if (err.message !== 'challenge') { toast('Could not sign you up here - opening the sign-up page.'); window.open((CFG.urls && CFG.urls.signup) || '/pages/sign-up', '_blank'); } if (onDone) { onDone(false); } });
    });
    return wrap;
  }

  /* ============================================================ the conversation (ElevenLabs) */
  function buildDynamicVariables(mode, extra) {
    var m = Memory.load();
    var picks = Memory.picks().slice(0, 10).map(function (p) { return p.title + ' (' + p.handle + ')'; }).join('; ');
    var recent = Memory.recent(12).map(function (l) { return (l.r === 'user' ? 'Customer: ' : (CFG.name || 'Hannah') + ': ') + l.t; }).join('\n');
    var cart = extra && extra.cart ? extra.cart : null;
    var pg = CFG.page || {};
    var prod = pg.product;
    var v = {
      hannah_mode: mode,
      page_type: pg.type || '', page_title: pg.title || '', page_url: location.href,
      current_product: prod ? (prod.title + ' (' + prod.handle + ', ' + money(prod.price) + ', ' + (prod.available ? 'in stock' : 'sold out') + ')') : '',
      current_collection: pg.collection ? (pg.collection.title + ' (' + pg.collection.handle + ')') : '',
      customer_first_name: (CFG.customer && CFG.customer.firstName) || '',
      customer_logged_in: !!(CFG.customer && CFG.customer.loggedIn),
      customer_subscribed: !!(CFG.customer && CFG.customer.acceptsMarketing),
      visit_count: m.visits || 1,
      past_picks: picks || 'none',
      recent_conversation: recent || 'none',
      memory_notes: Object.keys(m.notes || {}).length ? JSON.stringify(m.notes) : 'none',
      cart_summary: cart ? (cart.item_count + ' item(s), ' + money(cart.total_price) + ': ' + cart.items.slice(0, 6).map(function (i) { return i.quantity + 'x ' + i.product_title; }).join(', ')) : (CFG.cartCount ? CFG.cartCount + ' item(s)' : 'empty'),
      known_collections: (knownCollections().map(function (c) { return c.title + ' (' + c.handle + ')'; }).join(', ') || 'none') + (RULE.mode === 'exclude' && RULE.list.length ? '. Never recommend these collections: ' + RULE.list.map(function (c) { return c.title; }).join(', ') : (RULE.mode === 'allowed' ? '. Only recommend collections from this list.' : '')),
      subscriber_offer: CFG.subscriberOffer || '',
      signup_url: location.origin + ((CFG.urls && CFG.urls.signup) || '/pages/sign-up'),
      store_name: CFG.shopName || '', local_time: new Date().toLocaleString(),
      off_topic_strikes: Guard.strikes()
    };
    return v;
  }

  function buildClientTools(ui, session) {
    function arg(params, names, d) { params = params || {}; for (var i = 0; i < names.length; i++) { if (params[names[i]] != null && params[names[i]] !== '') { return params[names[i]]; } } return d; }
    function compact(p) {
      var s = p.specs || {}; var S = ['', 'mild', 'mild-medium', 'medium', 'medium-full', 'full'];
      var o = { handle: p.handle, title: p.title, vendor: p.vendor, price: money(p.price != null ? p.price : p.price_min), available: p.available !== false };
      if (p.price_max && p.price_max > p.price_min) { o.price = money(p.price_min) + '-' + money(p.price_max); }
      if (p.variant_count > 1) { o.options = p.variant_count + ' options'; }
      if (s.strength) { o.strength = S[Number(s.strength)] || s.strength; }
      ['wrapper_color', 'shape', 'length', 'ring', 'made_in', 'flavor'].forEach(function (k) { if (s[k]) { o[k] = s[k]; } });
      if (p.type) { o.type = p.type; }
      return o;
    }
    function resolve(handleOrTitle) {
      return Catalog.product(handleOrTitle).catch(function () {
        return Catalog.search(handleOrTitle, 3).then(function (r) {
          if (r.results && r.results[0]) { return Catalog.product(r.results[0].handle); }
          throw new Error('No product found for "' + handleOrTitle + '". Use search_products first and pass the exact handle.');
        });
      });
    }
    function wrap(name, fn) {
      return function (params) {
        log('tool', name, params);
        ui.onTool && ui.onTool(name, params);
        return Promise.resolve().then(function () { return fn(params || {}); }).then(function (r) {
          var out = typeof r === 'string' ? r : JSON.stringify(r);
          if (out.length > 6000) { out = out.slice(0, 6000) + '…'; }
          log('tool result', name, out.slice(0, 300));
          return out;
        }).catch(function (e) { log('tool error', name, e); Log.event('tool_error', { tool: name, message: e.message }); return JSON.stringify({ error: e.message }); });
      };
    }
    return {
      search_products: wrap('search_products', function (p) {
        var q = arg(p, ['query', 'q', 'search', 'text'], ''); var limit = arg(p, ['limit', 'max'], 8);
        return Catalog.search(q, limit).then(function (r) { return { query: q, found: r.count, results: r.results.map(compact), note: 'Use recommend_product with the handle to show one to the customer.' }; });
      }),
      get_product: wrap('get_product', function (p) {
        return resolve(arg(p, ['handle', 'product_handle', 'product', 'title'], '')).then(function (f) {
          var o = compact(f); o.description = (f.description || '').slice(0, 900); o.url = location.origin + f.url;
          o.variants = (f.variants || []).slice(0, 12).map(function (v) { return { id: v.id, title: v.title, price: money(v.price), available: v.available }; });
          o.collections = (f.collections || []).slice(0, 6).map(function (c) { return c.title + ' (' + c.handle + ')'; });
          if (f.specs) { ['aroma', 'body', 'wrapper_origin', 'wrapper_leaf', 'binder', 'filler', 'awards', 'rating', 'rating_count'].forEach(function (k) { if (f.specs[k]) { o[k] = f.specs[k]; } }); }
          return o;
        });
      }),
      browse_collection: wrap('browse_collection', function (p) {
        var h = arg(p, ['handle', 'collection_handle', 'collection'], ''); 
        return Catalog.collection(h, { page: arg(p, ['page'], 1), sort: arg(p, ['sort_by', 'sort'], ''), maxPrice: arg(p, ['max_price'], ''), minPrice: arg(p, ['min_price'], '') }).then(function (c) {
          return { title: c.title, handle: c.handle, total: c.count, page: c.page, pages: c.pages, products: (c.products || []).slice(0, 14).map(compact) };
        });
      }),
      list_collections: wrap('list_collections', function (p) {
        var q = String(arg(p, ['query', 'q'], '')).toLowerCase();
        var known = knownCollections().filter(function (c) { return !q || (c.title + ' ' + c.handle).toLowerCase().indexOf(q) > -1; }).map(function (c) { return { title: c.title, handle: c.handle, items: c.count }; });
        if (!q) { return { collections: known }; }
        return Catalog.suggestCollections(q).then(function (s) { s.forEach(function (c) { if (!excluded(c.handle) && !known.some(function (k) { return k.handle === c.handle; })) { known.push({ title: c.title, handle: c.handle }); } }); return { collections: known.slice(0, 20) }; });
      }),
      recommend_product: wrap('recommend_product', function (p) {
        var reason = arg(p, ['reason', 'why', 'note'], '');
        return resolve(arg(p, ['handle', 'product_handle', 'product', 'title'], '')).then(function (f) {
          ui.showPick(f, reason, { source: 'agent' });
          Memory.addPick(f, reason, session.id());
          Log.event('recommendation', { handle: f.handle, title: f.title, price: f.price, reason: reason, convId: session.id() });
          var o = compact(f); o.shown_to_customer = true; o.url = location.origin + f.url;
          o.variants = (f.variants || []).slice(0, 8).map(function (v) { return { id: v.id, title: v.title, price: money(v.price), available: v.available }; });
          return o;
        });
      }),
      show_products: wrap('show_products', function (p) {
        var hs = arg(p, ['handles', 'products', 'list'], []); if (typeof hs === 'string') { hs = hs.split(/[,\s]+/).filter(Boolean); }
        var title = arg(p, ['title', 'heading'], 'A few options');
        return Promise.all(hs.slice(0, 10).map(function (h) { return resolve(h).catch(function () { return null; }); })).then(function (list) {
          list = list.filter(Boolean);
          ui.showProducts(list, title);
          Log.event('products_shown', { handles: list.map(function (x) { return x.handle; }), title: title });
          return { shown: list.map(compact) };
        });
      }),
      show_collection: wrap('show_collection', function (p) {
        var ch = String(arg(p, ['handle', 'collection_handle', 'collection'], '')).trim().toLowerCase().replace(/^\/?collections\//, '').split('?')[0];
        if (excluded(ch)) { return { error: 'That collection is not available to recommend. Use list_collections to see the allowed ones.' }; }
        return Catalog.collection(ch).then(function (c) {
          ui.showCollection(c);
          Log.event('collection_shown', { handle: c.handle });
          return { title: c.title, handle: c.handle, total: c.count, sample: (c.products || []).slice(0, 8).map(compact) };
        });
      }),
      add_to_cart: wrap('add_to_cart', function (p) {
        var qty = arg(p, ['quantity', 'qty'], 1); var vid = arg(p, ['variant_id'], null); var vtitle = String(arg(p, ['variant_title', 'option', 'size'], '')).toLowerCase();
        var handle = arg(p, ['handle', 'product_handle', 'product'], '');
        var pick = function (f) {
          if (vid) { return vid; }
          var vs = f.variants || [];
          if (vtitle) { var m = vs.find(function (v) { return v.title.toLowerCase().indexOf(vtitle) > -1 && v.available; }); if (m) { return m.id; } }
          var ok = vs.filter(function (v) { return v.available; });
          if (ok.length === 1 || (ok.length && vs.length === 1)) { return ok[0].id; }
          if (ok.length > 1) { throw new Error('This product has several options: ' + ok.map(function (v) { return v.title + ' (' + money(v.price) + ')'; }).join(', ') + '. Ask which one, then call add_to_cart with variant_title.'); }
          throw new Error('Sold out.');
        };
        return (handle ? resolve(handle) : Promise.resolve(null)).then(function (f) {
          var variantId = f ? pick(f) : vid;
          if (!variantId) { throw new Error('Need a product handle or variant_id.'); }
          return Catalog.add(variantId, qty).then(function (j) {
            var item = j.items ? j.items[0] : j;
            Log.event('add_to_cart', { handle: handle, variantId: variantId, qty: Number(qty), title: item.product_title, price: item.price, via: 'agent', convId: session.id() });
            ui.onCart && ui.onCart(item);
            return Catalog.cart().then(function (c) { return { added: item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' - ' + item.variant_title : ''), quantity: Number(qty), cart_items: c.item_count, cart_total: money(c.total_price), checkout_url: location.origin + '/checkout' }; });
          });
        });
      }),
      get_cart: wrap('get_cart', function () {
        return Catalog.cart().then(function (c) { return { items: c.items.map(function (i) { return { title: i.product_title, variant: i.variant_title, qty: i.quantity, price: money(i.final_line_price), handle: i.handle }; }), total: money(c.total_price), count: c.item_count }; });
      }),
      open_signup: wrap('open_signup', function () {
        ui.showSignup();
        Log.event('signup_open', { convId: session.id() });
        return 'The sign-up form is on the customer’s screen now. Do not read the form aloud; carry on naturally.';
      }),
      remember: wrap('remember', function (p) {
        var k = arg(p, ['key', 'name', 'topic'], 'note'); var v = arg(p, ['value', 'text', 'note'], '');
        Memory.setNote(k, v); Log.event('remember', { key: k, value: v });
        return 'Saved: ' + k + ' = ' + v;
      }),
      recall_memory: wrap('recall_memory', function () {
        var m = Memory.load();
        return { visits: m.visits, notes: m.notes, past_picks: Memory.picks().slice(0, 12).map(function (p) { return { title: p.title, handle: p.handle, price: money(p.price), when: p.ts.slice(0, 10), reason: p.reason }; }), recent_conversation: Memory.recent(16).map(function (l) { return (l.r === 'user' ? 'Customer: ' : 'You: ') + l.t; }) };
      }),
      get_page_context: wrap('get_page_context', function () {
        var pg = CFG.page || {};
        return { page_type: pg.type, title: pg.title, url: location.href, product: pg.product ? compact(pg.product) : null, collection: pg.collection || null, customer: { first_name: CFG.customer && CFG.customer.firstName, logged_in: !!(CFG.customer && CFG.customer.loggedIn) } };
      }),
      end_call: wrap('end_call', function () { setTimeout(function () { session.end('agent'); }, 1200); return 'Ending.'; }),
      /* she calls this to end the call; off_topic / abuse also block this browser for a while */
      hang_up: wrap('hang_up', function (p) {
        var reason = String(arg(p, ['reason', 'why'], 'goodbye')).toLowerCase();
        if (reason === 'off_topic' || reason === 'abuse') { Guard.block(reason); }
        Log.event('agent_hang_up', { reason: reason, convId: session.id() });
        /* let her finish the goodbye line, then hang up (at most 7 seconds) */
        var t0 = Date.now(), quiet = 0;
        var iv = setInterval(function () {
          var speaking = session.mode && session.mode() === 'speaking';
          quiet = speaking ? 0 : quiet + 300;
          if ((Date.now() - t0 > 800 && quiet >= 700) || Date.now() - t0 > 5000) { clearInterval(iv); session.end(reason); }
        }, 300);
        ui.onHangUp && ui.onHangUp(reason);
        return 'The call will end after your goodbye.';
      })
    };
  }

  /* WebSocket is the reliable default: WebRTC (LiveKit) is blocked by some networks,
     browsers and extensions. If WebRTC is chosen in Theme settings and fails once in
     this browser, we remember that and use WebSocket from then on. */
  function connType(textOnly) {
    if (textOnly) { return 'websocket'; }
    if (CFG.connection !== 'webrtc') { return 'websocket'; }
    return Memory.pref('webrtcFailed') ? 'websocket' : 'webrtc';
  }

  /* Session: a thin, UI-agnostic wrapper over Conversation.startSession */
  function createSession(ui, opts) {
    opts = opts || {};
    var conv = null, convId = null, status = 'disconnected', mode = 'listening', startedAt = 0, msgCount = 0, muted = false, ending = false;
    var api = {
      id: function () { return convId; },
      status: function () { return status; },
      isOpen: function () { return !!conv && status === 'connected'; },
      mode: function () { return mode; },
      kind: opts.mode || 'voice',
      outFreq: function () { try { return conv ? conv.getOutputByteFrequencyData() : null; } catch (e) { return null; } },
      inFreq: function () { try { return conv ? conv.getInputByteFrequencyData() : null; } catch (e) { return null; } },
      outVol: function () { try { return conv ? conv.getOutputVolume() : 0; } catch (e) { return 0; } },
      inVol: function () { try { return conv && !muted ? conv.getInputVolume() : 0; } catch (e) { return 0; } },
      muted: function () { return muted; },
      setMuted: function (b) { muted = !!b; try { conv && conv.setMicMuted(muted); } catch (e) {} ui.onMute && ui.onMute(muted); },
      setVolume: function (v) { try { conv && conv.setVolume({ volume: clamp(v, 0, 1) }); } catch (e) {} },
      send: function (text) {
        text = String(text || '').trim(); if (!text) { return Promise.resolve(); }
        var go = function () { conv.sendUserMessage(text); };
        if (api.isOpen()) { go(); return Promise.resolve(); }
        return api.start().then(go);
      },
      context: function (text) { try { conv && conv.sendContextualUpdate(text); } catch (e) {} },
      activity: function () { try { conv && conv.sendUserActivity(); } catch (e) {} },
      start: function () {
        if (conv) { return Promise.resolve(conv); }
        var agentId = (opts.agentId || CFG.agentId || '').trim();
        if (!agentId) { var err = new Error('No ElevenLabs Agent ID. Add it in Theme settings -> Hannah.'); ui.onError && ui.onError(err.message); return Promise.reject(err); }
        setStatus('connecting');
        var textOnly = opts.mode === 'text';
        return Promise.all([loadSDK(), Catalog.cart().catch(function () { return null; })]).then(function (res) {
          var SDK = res[0], cart = res[1];
          var cfg = {
            agentId: agentId,
            connectionType: connType(textOnly),
            textOnly: textOnly,
            dynamicVariables: buildDynamicVariables(opts.mode, { cart: cart }),
            clientTools: buildClientTools(ui, api),
            userId: Memory.load().sessionId,
            onConnect: function (p) { convId = p.conversationId; startedAt = Date.now(); msgCount = 0; setStatus('connected'); Memory.newConversation(convId, opts.mode, location.pathname); Log.event('session_start', { convId: convId, mode: opts.mode, agentId: agentId }); },
            onDisconnect: function (d) { if (!textOnly && startedAt && Date.now() - startedAt < 4000 && connType(false) === 'webrtc') { Memory.pref('webrtcFailed', true); } var c = convId; var dur = startedAt ? Math.round((Date.now() - startedAt) / 1000) : 0; conv = null; setStatus('disconnected'); Memory.endConversation(c); Log.event('session_end', { convId: c, mode: opts.mode, seconds: dur, messages: msgCount, reason: d && d.reason, detail: d && d.message }); ui.onEnd && ui.onEnd(d); if (d && d.reason === 'error') { ui.onError && ui.onError(d.message || 'Connection lost'); } convId = null; },
            onError: function (m, ctx) { log('error', m, ctx); Log.event('error', { message: String(m) }); ui.onError && ui.onError(String(m)); },
            onModeChange: function (p) { mode = p.mode; ui.onMode && ui.onMode(mode); },
            onStatusChange: function (p) { if (p.status !== status) { setStatus(p.status); } },
            onMessage: function (p) {
              var role = p.role || (p.source === 'ai' ? 'agent' : 'user');
              msgCount++;
              Memory.addMsg(role, p.message, convId, opts.mode);
              Log.event('message', { role: role, text: p.message, convId: convId });
              ui.onMessage && ui.onMessage(role, p.message, p);
            },
            onAgentChatResponsePart: function (p) { ui.onPart && ui.onPart(p); },
            onUnhandledClientToolCall: function (p) { log('unhandled tool', p); Log.event('tool_unhandled', { tool: p && p.tool_name }); },
            onInterruption: function () { ui.onInterrupt && ui.onInterrupt(); }
          };
          if (opts.firstMessage || opts.language) { cfg.overrides = { agent: {} }; if (opts.firstMessage) { cfg.overrides.agent.firstMessage = opts.firstMessage; } if (opts.language) { cfg.overrides.agent.language = opts.language; } }
          return SDK.Conversation.startSession(cfg);
        }).then(function (c) { conv = c; return c; }).catch(function (e) {
          conv = null; setStatus('disconnected');
          if (!textOnly && connType(false) === 'webrtc') {
            Memory.pref('webrtcFailed', true);
            Log.event('webrtc_fallback', { message: String(e && e.message || e) });
            return api.start();
          }
          var msg = /NotAllowedError|Permission|denied/i.test(String(e && (e.message || e.name))) ? 'Microphone access was blocked. Allow the microphone, or use the chat page instead.' : (e && e.message) || 'Could not connect';
          ui.onError && ui.onError(msg); Log.event('error', { message: msg, phase: 'start' });
          throw e;
        });
      },
      end: function (why) {
        if (!conv || ending) { return Promise.resolve(); }
        ending = true; var c = conv;
        return c.endSession().catch(function () {}).then(function () { ending = false; conv = null; if (status !== 'disconnected') { setStatus('disconnected'); } });
      }
    };
    function setStatus(s) { status = s; ui.onStatus && ui.onStatus(s); }
    return api;
  }
  H.createSession = createSession;

  /* ============================================================ live avatar (Anam)
     Anam renders Hannah's lip-synced face and connects to the SAME ElevenLabs agent
     on the server side. The ElevenLabs client tools (search, recommend, add to cart...)
     are forwarded by Anam to this page and answered by the same handlers as above.
     A token comes from the Hannah Worker (server/hannah-anam-worker.js), which keeps
     the Anam and ElevenLabs keys secret. Same interface as createSession(). */
  var anamPromise = null;
  function loadAnam() {
    if (window.anam && window.anam.createClient) { return Promise.resolve(window.anam); }
    if (anamPromise) { return anamPromise; }
    anamPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = CFG.anamSdkUrl; s.async = true;
      s.onload = function () { if (window.anam && window.anam.createClient) { resolve(window.anam); } else { reject(new Error('Anam SDK loaded but createClient is missing')); } };
      s.onerror = function () { anamPromise = null; reject(new Error('Could not load the Anam SDK')); };
      document.head.appendChild(s);
    });
    return anamPromise;
  }
  function createAnamSession(ui, opts) {
    opts = opts || {};
    var client = null, status = 'disconnected', mode = 'listening', startedAt = 0, msgCount = 0, muted = false;
    var convId = null, starting = null, closed = true, bufs = {}, order = [], unreg = [];
    var audioCtx = null, analyser = null, freq = null;
    var video = opts.video;
    function setStatus(x) { status = x; ui.onStatus && ui.onStatus(x); }
    function setMode(m) { if (m !== mode) { mode = m; ui.onMode && ui.onMode(m); } }
    function flush(id) {
      var b = bufs[id]; if (!b) { return; }
      delete bufs[id]; order = order.filter(function (x) { return x !== id; });
      var t = b.text.trim(); if (!t) { return; }
      msgCount++;
      Memory.addMsg(b.role, t, convId, 'voice');
      Log.event('message', { role: b.role, text: t, convId: convId });
      ui.onMessage && ui.onMessage(b.role, t, {});
    }
    function onStream(e) {
      if (!e || !e.id) { return; }
      var role = e.role === 'user' ? 'user' : 'agent';
      if (!bufs[e.id]) {
        /* a new message from the other side means the previous one is finished */
        order.slice().forEach(function (id) { if (bufs[id] && bufs[id].role !== role) { flush(id); } });
        bufs[e.id] = { role: role, text: '' }; order.push(e.id);
      }
      bufs[e.id].text += e.content || '';
      if (role === 'agent') { setMode(e.endOfSpeech || e.interrupted ? 'listening' : 'speaking'); }
      ui.onLive && ui.onLive(role, bufs[e.id].text);
      if (e.endOfSpeech || e.interrupted) { flush(e.id); }
    }
    function attachAnalyser() {
      try {
        var stream = video && video.srcObject;
        if (!stream || !stream.getAudioTracks || !stream.getAudioTracks().length) { return; }
        var AC = window.AudioContext || window.webkitAudioContext; if (!AC) { return; }
        audioCtx = new AC();
        var src = audioCtx.createMediaStreamSource(stream);
        analyser = audioCtx.createAnalyser(); analyser.fftSize = 256;
        freq = new Uint8Array(analyser.frequencyBinCount);
        src.connect(analyser); /* not to the speakers: the video element already plays the sound */
      } catch (e) { analyser = null; }
    }
    function cleanup() {
      unreg.forEach(function (u) { try { u(); } catch (e) {} }); unreg = [];
      try { audioCtx && audioCtx.close(); } catch (e) {} audioCtx = null; analyser = null;
    }
    function onClosed(reason) {
      if (closed) { return; }
      closed = true;
      order.slice().forEach(flush);
      cleanup();
      var c = convId, dur = startedAt ? Math.round((Date.now() - startedAt) / 1000) : 0;
      client = null;
      Memory.endConversation(c);
      Log.event('session_end', { convId: c, mode: 'voice', engine: 'anam', seconds: dur, messages: msgCount, reason: String(reason || '') });
      setMode('listening'); setStatus('disconnected');
      ui.onVideo && ui.onVideo(false);
      ui.onEnd && ui.onEnd({ reason: reason });
      convId = null;
    }
    var api = {
      kind: 'voice', engine: 'anam',
      id: function () { return convId; },
      status: function () { return status; },
      isOpen: function () { return !!client && status === 'connected'; },
      mode: function () { return mode; },
      outFreq: function () { if (!analyser) { return null; } analyser.getByteFrequencyData(freq); return freq; },
      outVol: function () {
        if (!analyser) { return mode === 'speaking' ? .35 : 0; }
        analyser.getByteFrequencyData(freq); var sum = 0; for (var i = 0; i < freq.length; i++) { sum += freq[i]; }
        return sum / freq.length / 255 * 1.8;
      },
      inFreq: function () { return null; },
      inVol: function () { return 0; },
      muted: function () { return muted; },
      setMuted: function (b) { muted = !!b; try { if (client) { if (muted) { client.muteInputAudio(); } else { client.unmuteInputAudio(); } } } catch (e) {} ui.onMute && ui.onMute(muted); },
      setVolume: function (v) { if (video) { video.volume = clamp(v, 0, 1); } },
      send: function (text) {
        text = String(text || '').trim(); if (!text) { return Promise.resolve(); }
        if (api.isOpen()) { try { client.sendUserMessage(text); } catch (e) {} return Promise.resolve(); }
        return api.start().then(function () { try { client.sendUserMessage(text); } catch (e) {} });
      },
      context: function (text) { try { client && client.addContext(text); } catch (e) {} },
      activity: function () {},
      start: function () {
        if (starting) { return starting; }
        if (client) { return Promise.resolve(client); }
        if (!CFG.anamUrl) { return Promise.reject(new Error('No live avatar server URL in Theme settings.')); }
        setStatus('connecting');
        starting = Promise.all([loadAnam(), Catalog.cart().catch(function () { return null; })]).then(function (res) {
          var A = res[0], cart = res[1];
          return fetch(CFG.anamUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ dynamicVariables: buildDynamicVariables('voice', { cart: cart }), userId: Memory.load().sessionId })
          }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (j) {
              if (!r.ok || !j.sessionToken) { var er = new Error(j.error || ('Live avatar server error ' + r.status)); er.status = r.status; throw er; }
              return [A, j.sessionToken];
            });
          });
        }).then(function (res) {
          var A = res[0];
          client = A.createClient(res[1]);
          closed = false; bufs = {}; order = [];
          var tools = buildClientTools(ui, api);
          Object.keys(tools).forEach(function (name) {
            if (name === 'end_call') { return; }
            unreg.push(client.registerToolCallHandler(name, { onStart: function (p) { return tools[name]((p && p.arguments) || {}); } }));
          });
          client.addListener('MESSAGE_STREAM_EVENT_RECEIVED', onStream);
          client.addListener('CONNECTION_CLOSED', function (code, details) { onClosed(details || code || 'closed'); });
          client.addListener('VIDEO_PLAY_STARTED', function () { ui.onVideo && ui.onVideo(true); attachAnalyser(); });
          client.addListener('USER_SPEECH_STARTED', function () { setMode('listening'); ui.onUserSpeech && ui.onUserSpeech(); });
          client.addListener('TALK_STREAM_INTERRUPTED', function () { setMode('listening'); ui.onInterrupt && ui.onInterrupt(); });
          client.addListener('MIC_PERMISSION_DENIED', function () { ui.onError && ui.onError('Microphone access was blocked. Allow the microphone, or use the chat page instead.'); });
          /* "connected" only once her session is really ready (or her video plays): sending
             a message before that is what made the early suggestion buttons drop the call */
          var c = client;
          var ready = new Promise(function (resolve, reject) {
            var t = setTimeout(resolve, 15000);
            var ok = function () { clearTimeout(t); resolve(); };
            ['SESSION_READY', 'VIDEO_PLAY_STARTED'].forEach(function (ev) { try { c.addListener(ev, ok); } catch (e) {} });
            try { c.addListener('CONNECTION_CLOSED', function (code, details) { clearTimeout(t); reject(new Error('Live avatar closed while connecting: ' + (details || code || ''))); }); } catch (e) {}
          });
          return client.streamToVideoElement(video.id).then(function () { return ready; });
        }).then(function () {
          convId = (client.getActiveSessionId && client.getActiveSessionId()) || ('anam-' + uid());
          startedAt = Date.now(); msgCount = 0; starting = null;
          Memory.newConversation(convId, 'voice', location.pathname);
          Log.event('session_start', { convId: convId, mode: 'voice', engine: 'anam' });
          setStatus('connected');
          return client;
        }).catch(function (e) {
          starting = null;
          var c = client; client = null; closed = true; cleanup();
          if (c) { try { c.stopStreaming(); } catch (x) {} }
          setStatus('disconnected');
          Log.event('error', { message: String(e && e.message || e), phase: 'anam_start' });
          throw e;
        });
        return starting;
      },
      end: function (why) {
        if (!client) { return Promise.resolve(); }
        var c = client;
        return Promise.resolve().then(function () { return c.stopStreaming(); }).catch(function () {}).then(function () { onClosed(why || 'user'); });
      }
    };
    return api;
  }
  H.createAnamSession = createAnamSession;

  /* ============================================================ shared UI helpers */
  function injectHTML(host, html) {
    host.innerHTML = html || '';
    $$('script', host).forEach(function (old) { var s = document.createElement('script'); [].forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); }); s.text = old.text; old.replaceWith(s); });
  }
  function readSettings(root) { try { return JSON.parse(root.getAttribute('data-settings') || '{}'); } catch (e) { return {}; } }
  function avatarMarkup(host) {
    host.innerHTML = '';
    if (CFG.avatarEmbed) { var e = el('div', { class: 'hannah-avatar__embed' }); host.appendChild(e); injectHTML(e, CFG.avatarEmbed); }
    else if (CFG.idleVideo) { host.appendChild(el('video', { src: CFG.idleVideo, autoplay: true, muted: true, loop: true, playsinline: true, poster: CFG.portrait || null })); var v = host.lastChild; v.muted = true; }
    else if (CFG.portrait) { host.appendChild(el('img', { src: CFG.portrait, alt: CFG.name || 'Hannah' })); }
    else { host.appendChild(el('div', { class: 'hannah-avatar__placeholder', html: '<div class="halo"></div><div class="silhouette"></div>' })); }
    var badge = tx('badge', TXT.badge === '' ? '' : 'AI concierge');
    if (badge) { host.appendChild(el('span', { class: 'hannah-avatar__badge', text: badge })); }
  }
  /* Collections rule (Stage section): "allowed" = only the picked collections are ever
     recommended; "exclude" = any collection except the picked ones. The theme's
     "Never show these collections" list always applies too. */
  var RULE = { mode: 'exclude', list: [], handles: [] };
  function setCollectionRule(mode, list) {
    list = (list || []).filter(function (c) { return c && c.handle; });
    RULE = { mode: mode === 'allowed' ? 'allowed' : 'exclude', list: list, handles: list.map(function (c) { return c.handle; }) };
  }
  function excluded(handle) {
    if (!handle) { return true; }
    if ((CFG.excludeCollections || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean).indexOf(handle) > -1) { return true; }
    if (RULE.mode === 'allowed') { return RULE.handles.indexOf(handle) < 0; }
    return RULE.handles.indexOf(handle) > -1;
  }
  /* every collection in the store, for the "exclude" rule when no list is chosen in Theme settings */
  var storeCollections = null;
  function loadStoreCollections() {
    if (storeCollections) { return Promise.resolve(storeCollections); }
    return fetchJSON('/collections.json?limit=250').then(function (r) {
      storeCollections = (r.collections || []).map(function (c) { return { title: c.title, handle: c.handle, url: '/collections/' + c.handle, image: c.image && c.image.src, count: c.products_count || null }; });
      return storeCollections;
    }).catch(function () { storeCollections = []; return storeCollections; });
  }
  /* ---- collections ----
     No conversation yet: a random mix of the collections chosen in Theme settings.
     During a conversation: the ones that match her pick and what was said, best first;
     random ones only fill the gaps. */
  var STOP = ' the and for with you your our are was were this that from have has had but not all any can will just what when who how why about into out off over very more most some such only own same than too also its it his her they them then there here a an of to in on at by or as be is am do did does so if no yes me my we us i hi hello hey cigar cigars inc '.split(' ');
  function shuffle(list) { var a = list.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function words(text) {
    return String(text || '').toLowerCase().replace(/[^a-z0-9\s-]/g, ' ').split(/[\s-]+/).filter(function (w) { return w.length > 2 && STOP.indexOf(w) < 0; });
  }
  function knownCollections() {
    var pool = RULE.mode === 'allowed' ? RULE.list : ((CFG.knownCollections || []).length ? CFG.knownCollections : (storeCollections || []));
    return pool.filter(function (c) { return c && c.handle && !excluded(c.handle); });
  }
  function randomCollections(n) { return shuffle(knownCollections()).slice(0, n); }
  function relatedCollections(f, n) {
    var talk = Memory.recent(8).map(function (l) { return l.t; }).join(' ');
    var vendor = words(f.vendor), type = words(f.type), title = words(f.title), said = words(talk), tags = words((f.tags || []).join(' '));
    var scored = {};
    function add(c, pts) {
      if (!c || !c.handle || excluded(c.handle)) { return; }
      var k = c.handle; if (!scored[k]) { scored[k] = { c: c, score: 0 }; }
      scored[k].score += pts; if (!scored[k].c.image && c.image) { scored[k].c = c; }
    }
    /* the pick's own collections (needs the product.hannah template) */
    (f.collections || []).forEach(function (c) { add(c, 6); });
    /* the chosen collections, scored by how well their name matches */
    knownCollections().forEach(function (c) {
      var name = words(c.title + ' ' + c.handle), pts = 0;
      name.forEach(function (w) {
        if (vendor.indexOf(w) > -1) { pts += 5; }
        else if (type.indexOf(w) > -1) { pts += 3; }
        else if (title.indexOf(w) > -1) { pts += 2; }
        else if (tags.indexOf(w) > -1) { pts += 1; }
        else if (said.indexOf(w) > -1) { pts += 1; }
      });
      if (pts) { add(c, pts + 1); }
    });
    var ranked = function () {
      return Object.keys(scored).map(function (k) { return scored[k]; })
        .sort(function (a, b) { return (b.score - a.score) || (Math.random() - .5); })
        .map(function (x) { return x.c; });
    };
    var finish = function () {
      var out = ranked().slice(0, n);
      shuffle(knownCollections()).forEach(function (c) { if (out.length < n && !out.some(function (x) { return x.handle === c.handle; })) { out.push(c); } });
      return out;
    };
    if (ranked().length >= n) { return Promise.resolve(finish()); }
    /* not enough matches yet: ask the store's own search for collections about the brand and type */
    var q = [f.vendor, f.type].filter(Boolean).join(' ') || f.title || '';
    return Catalog.suggestCollections(q).then(function (list) { list.forEach(function (c) { add(c, 3); }); return finish(); }).catch(finish);
  }
  function collectionsBlock(slot, cols, title, style) {
    slot.innerHTML = '';
    cols = cols.filter(function (c) { return !excluded(c.handle); });
    if (!cols.length) { return; }
    var list = style === 'buttons'
      ? el('div', { class: 'h-coll-buttons' }, cols.map(function (c) { return el('a', { class: 'h-coll-btn', href: c.url || ('/collections/' + c.handle), text: c.title }); }))
      : el('div', { class: 'h-grid h-grid--colls' }, cols.map(collectionCard));
    var block = sideBlock(title, list); if (style === 'buttons') { block.classList.add('is-buttons'); }
    slot.appendChild(block);
  }
  function loadRelated(f, n) {
    return Catalog.related(f.id, n).then(function (list) {
      if (list.length) { return list; }
      var c = (f.collections || []).find(function (x) { return !excluded(x.handle); });
      if (!c) { return []; }
      return Catalog.collection(c.handle).then(function (col) { return (col.products || []).filter(function (p) { return p.handle !== f.handle; }).slice(0, n); });
    }).catch(function () { return []; });
  }
  function sideBlock(title, node, link) {
    var h = el('div', { class: 'h-side-title' }, [el('h3', { text: title })]);
    if (link) { h.appendChild(link); }
    return el('div', {}, [h, node]);
  }

  /* ============================================================ STAGE */
  function initStage(root) {
    if (root.__hannah) { return root.__hannah; }
    var S = readSettings(root); var L = S.labels || {};
    Object.keys(L).forEach(function (k) { if (L[k] != null) { TXT[k] = L[k]; } });
    if (S.collectionRule) { setCollectionRule(S.collectionRule, S.ruleCollections); }
    if (S.guard) { CFG.guard = S.guard; }
    var isText = S.mode === 'text';
    var scene = $('[data-scene]', root), avatarEl = $('[data-avatar]', root), waveHost = $('[data-wave]', root), caption = $('[data-caption]', root);
    var controls = $('[data-controls]', root), transcriptEl = $('[data-transcript]', root), composer = $('[data-composer]', root), side = $('[data-side]', root);
    var slots = { signup: $('[data-slot="signup"]', root), pick: $('[data-slot="pick"]', root), alts: $('[data-slot="alts"]', root), related: $('[data-slot="related"]', root), collections: $('[data-slot="collections"]', root) };
    var galaxy = null, bubbles = null, wave = null, raf = 0, destroyed = false, currentPick = null, captionTimer = null;
    var transcript = Transcript(transcriptEl);

    avatarMarkup(avatarEl);
    var showAvatar = S.showAvatar !== false;
    var useAnam = !isText && CFG.faceMode === 'anam' && !!CFG.anamUrl;
    var liveVideo = null;
    if (useAnam) {
      liveVideo = el('video', { class: 'hannah-avatar__live', id: 'hannah-live-' + (root.getAttribute('data-section-id') || uid()), autoplay: true, playsinline: true });
      avatarEl.appendChild(liveVideo);
    }
    if (S.galaxy !== false) { galaxy = Galaxy($('[data-galaxy]', root), { stars: Math.min(S.stars || 120, 220), speed: S.galaxySpeed, accent: cssVar(root, '--h-accent', S.accent), ink: cssVar(root, '--h-text', '#1c1d1d'), lines: true }); }
    bubbles = Bubbles($('[data-bubbles]', root), { max: S.bubbles, size: S.bubbleSize, speed: S.bubbleSpeed, label: L.bubbles, onOpen: function (item) { reopen(item.handle, L.fromMemory || 'From an earlier chat'); } });
    bubbles.set(Memory.picks());
    document.addEventListener('hannah:memory', function () { bubbles.set(Memory.picks()); });

    /* ---- controls ---- */
    var btnStart = el('button', { class: 'h-btn h-btn--solid h-btn--big', type: 'button', html: icon('mic') + '<span>' + esc(L.start || 'Talk to Hannah') + '</span>' });
    var btnEnd = el('button', { class: 'h-btn h-btn--danger', type: 'button', html: icon('phoneOff') + '<span>' + esc(L.end || 'End') + '</span>', hidden: true });
    var btnMute = el('button', { class: 'h-btn h-btn--icon', type: 'button', title: L.mute || 'Mute', 'aria-label': L.mute || 'Mute', html: icon('mic'), hidden: true });
    var btnAvatar = el('button', { class: 'h-btn', type: 'button', html: icon('eyeOff') + '<span>' + esc(L.hide || 'Hide Hannah') + '</span>' });
    var btnCC = el('button', { class: 'h-btn h-btn--icon', type: 'button', title: L.captions || 'Captions', 'aria-label': L.captions || 'Captions', html: icon('cc') });
    var btnTranscript = el('button', { class: 'h-btn h-btn--icon', type: 'button', title: L.transcript || 'Transcript', 'aria-label': L.transcript || 'Transcript', html: icon('list') });
    var btnMemory = el('button', { class: 'h-btn', type: 'button', html: icon('clock') + '<span>' + esc(L.memory || 'Past picks') + '</span>' });
    var btnType = el('button', { class: 'h-btn h-btn--icon', type: 'button', title: L.type || 'Type instead', 'aria-label': L.type || 'Type instead', html: icon('keyboard') });
    var btnNew = el('button', { class: 'h-btn', type: 'button', html: icon('spark') + '<span>' + esc(L.newChat || 'New conversation') + '</span>', hidden: true });
    var statusEl = el('span', { class: 'h-status' }, [el('i', { class: 'h-dot' + (Guard.left() ? ' is-blocked' : ''), 'data-status': 'disconnected' }), el('span', { text: L.idle || 'Ready' }), el('span', { class: 'hannah-mic-level', hidden: true }, [el('i')])]);
    if (!isText) { [btnStart, btnEnd, btnMute, btnAvatar, btnCC, btnTranscript, btnType, btnMemory, statusEl].forEach(function (b) { controls.appendChild(b); }); }
    else { [btnMemory, btnNew, btnAvatar, statusEl].forEach(function (b) { controls.appendChild(b); }); }
    if (S.switchUrl && S.switchLabel) { controls.appendChild(el('a', { class: 'h-btn h-btn--ghost', href: S.switchUrl, html: (isText ? icon('mic') : icon('keyboard')) + '<span>' + esc(S.switchLabel) + '</span>' })); }

    var captionsOn = Memory.pref('captions') != null ? !!Memory.pref('captions') : S.captions !== false;
    var avatarHidden = !showAvatar || !!Memory.pref('avatarHidden');
    if (!showAvatar) { btnAvatar.hidden = true; root.classList.add('no-avatar'); }
    var showTranscript = !!Memory.pref('stageTranscript') || S.showTranscript === true;
    function applyPrefs() {
      root.classList.toggle('is-avatar-hidden', avatarHidden);
      btnAvatar.innerHTML = (avatarHidden ? icon('eye') : icon('eyeOff')) + '<span>' + esc(avatarHidden ? (L.show || 'Show Hannah') : (L.hide || 'Hide Hannah')) + '</span>';
      btnCC.classList.toggle('is-on', captionsOn); caption.hidden = !captionsOn;
      root.classList.toggle('show-transcript', showTranscript || isText); btnTranscript.classList.toggle('is-on', showTranscript);
      if (avatarHidden && !wave) { wave = Wave($('canvas', waveHost), function () { return session.outFreq(); }, function () { return session.outVol(); }, S.accent || '#e3b261'); }
    }
    btnAvatar.onclick = function () { if (!showAvatar) { return; } avatarHidden = !avatarHidden; Memory.pref('avatarHidden', avatarHidden); applyPrefs(); Log.event('avatar_toggle', { hidden: avatarHidden }); };
    btnCC.onclick = function () { captionsOn = !captionsOn; Memory.pref('captions', captionsOn); applyPrefs(); };
    btnTranscript.onclick = function () { showTranscript = !showTranscript; Memory.pref('stageTranscript', showTranscript); applyPrefs(); };
    btnMemory.onclick = function () { openMemorySheet(function (pk) { reopen(pk.handle, L.fromMemory || 'From an earlier chat'); }); };
    btnType.onclick = function () { composer.hidden = !composer.hidden; if (!composer.hidden) { $('input', composer).focus(); } };
    btnNew.onclick = function () { session.end('user').then(function () { transcript.clear(); transcript.system(L.newChatNote || 'New conversation. She still remembers your past picks.'); }); };

    /* ---- composer ---- */
    var input = $('input', composer);
    composer.hidden = !isText && !S.allowTyping;
    if (!isText && S.allowTyping) { composer.hidden = true; } else { btnType.hidden = true; }
    composer.addEventListener('submit', function (e) {
      e.preventDefault(); var t = input.value.trim(); if (!t) { return; }
      input.value = '';
      ask(t);
    });
    input.addEventListener('input', function () { session.activity(); });
    $$('[data-quick] button', root).forEach(function (b) { b.addEventListener('click', function () { quick(b); }); });

    /* ---- suggestion buttons ----
       Each button can open a collection page, show products (a collection or the whole
       store, with a price range) right here, and/or ask Hannah. On the face-to-face page
       the call is started first and the question is sent once she is ready to listen. */
    var pendingSay = null, saidAt = 0, saidText = '', userEnded = false, modeHook = null;
    function quick(b) {
      var say = (b.getAttribute('data-say') || b.textContent).trim();
      var title = (b.getAttribute('data-title') || b.textContent).trim();
      var action = b.getAttribute('data-action') || 'ask', handle = b.getAttribute('data-handle') || '', url = b.getAttribute('data-url') || '';
      var min = parseFloat(b.getAttribute('data-min')) || 0, max = parseFloat(b.getAttribute('data-max')) || 0;
      Log.event('quick_click', { text: title, action: action, collection: handle, min: min, max: max });
      if (action === 'link' && url) { location.href = url; return; }
      if (handle) { showRange(handle, min, max, title, url); }
      if (action === 'products' && handle) { return; }
      ask(say);
    }
    function ask(t) {
      if (!session.isOpen() && !Guard.check()) { return; }
      turnPicks = [];
      if (isText || session.isOpen()) {
        if (!session.isOpen()) { transcript.user(t); }
        session.send(t).catch(function () {});
        if (!isText) { saidAt = Date.now(); saidText = t; }
        return;
      }
      transcript.user(t);
      pendingSay = t;
      if (session.status() !== 'connecting') { startVoice(); }
    }
    /* wait for her greeting to finish (or a few seconds), then ask */
    function sendWhenReady(t) {
      var done = false, spoke = false, timer = setTimeout(go, 6000);
      function go() { if (done) { return; } done = true; clearTimeout(timer); modeHook = null; saidAt = Date.now(); saidText = t; session.send(t).catch(function () {}); }
      modeHook = function (m) {
        if (m === 'speaking') { spoke = true; clearTimeout(timer); timer = setTimeout(go, 12000); }
        else if (spoke) { clearTimeout(timer); timer = setTimeout(go, 500); }
      };
    }
    function inRange(p, min, max) { var price = (p.price || 0) / 100; return (!min || price >= min) && (!max || price <= max); }
    function showRange(handle, min, max, title, url) {
      var n = S.chipProducts || 8, o = { sort: 'best-selling', minPrice: min || null, maxPrice: max || null };
      slots.alts.innerHTML = '';
      root.classList.add('has-pick');
      Catalog.collection(handle, o).then(function (c) {
        var list = (c.products || []).filter(function (p) { return inRange(p, min, max); });
        if (list.length >= Math.min(3, n) || (!min && !max)) { return { c: c, list: list }; }
        /* the store's price filter is off: sort by price instead and filter here */
        o.sort = (min && !max) ? 'price-descending' : 'price-ascending';
        return Catalog.collection(handle, o).then(function (c2) {
          var more = (c2.products || []).filter(function (p) { return inRange(p, min, max); });
          return { c: c, list: list.concat(more.filter(function (p) { return !list.some(function (x) { return x.handle === p.handle; }); })) };
        });
      }).then(function (r) {
        var list = r.list.filter(function (p) { return p.available !== false; }).slice(0, n);
        if (!list.length) { return; }
        var grid = el('div', { class: 'h-grid', style: '--h-cols:' + (list.length > 6 ? 4 : list.length > 4 ? 3 : 2) }, list.map(function (p) { return productCard(p, 'small', { newTab: true }); }));
        slots.alts.appendChild(sideBlock(title, grid, url ? el('a', { href: url, text: tx('seeAll', 'See all') }) : null));
        reveal(slots.alts);
      }).catch(function (e) { log('quick products failed', e); });
    }

    /* ---- the session ---- */
    var ui = {
      onStatus: function (s) {
        $('.h-dot', statusEl).setAttribute('data-status', s);
        $('.h-dot + span', statusEl).textContent = { connecting: L.connecting || 'Connecting…', connected: isText ? 'Online' : (L.connected || 'Listening'), disconnected: L.idle || 'Ready', disconnecting: '…' }[s] || s;
        var live = s === 'connected' || s === 'connecting';
        btnStart.hidden = live; btnEnd.hidden = !live; btnMute.hidden = !live || isText; $('.hannah-mic-level', statusEl).hidden = !live || isText;
        btnNew.hidden = !live;
        btnStart.disabled = s === 'connecting';
        root.setAttribute('data-status', s);
        if (s === 'connected' && !isText) {
          transcript.system(L.connectedNote || 'Connected. Just talk - she can hear you.');
          if (pendingSay) { var t = pendingSay; pendingSay = null; sendWhenReady(t); }
        }
        if (s === 'connected') { userEnded = false; if (!isText) { dog.start(); } }
        if (s === 'disconnected') { dog.stop(); }
      },
      onMode: function (m) { if (modeHook) { modeHook(m); } dog.activity(); root.setAttribute('data-mode', m); $('.h-dot', statusEl).setAttribute('data-mode', m); if (!isText) { $('.h-dot + span', statusEl).textContent = m === 'speaking' ? (L.speaking || 'Speaking') : (L.connected || 'Listening'); } },
      onMute: function (m) { btnMute.innerHTML = m ? icon('micOff') : icon('mic'); btnMute.classList.toggle('is-on', m); },
      onMessage: function (role, text) {
        if (role === 'user') { dog.activity(); turnPicks = []; transcript.user(text); if (!isText) { setCaption(text, true); } }
        else { transcript.agentFinal(text); if (!isText) { setCaption(text, false); } }
      },
      onPart: function (p) { if (!isText) { return; } if (p.type === 'start') { transcript.agentStart(); } else if (p.type === 'delta' || (!p.type && p.text)) { transcript.agentDelta(p.text || ''); } },
      onInterrupt: function () { clearTimeout(captionTimer); },
      onLive: function (role, text) { if (role === 'user') { dog.activity(); } if (!isText) { setCaption(text, role === 'user'); } },
      onUserSpeech: function () { dog.activity(); },
      onHangUp: function (reason) {
        userEnded = true;
        if (reason === 'off_topic' || reason === 'abuse') { setTimeout(function () { transcript.system(Guard.opts().msg); }, 1500); }
      },
      onVideo: function (on) { avatarEl.classList.toggle('is-live', !!on); },
      onEnd: function () {
        root.removeAttribute('data-mode'); modeHook = null;
        if (!isText && !userEnded && session.engine === 'anam' && saidAt && Date.now() - saidAt < 20000) {
          /* the live face dropped right after a typed or button question: carry on by voice and ask again */
          pendingSay = saidText; saidAt = 0;
          Log.event('anam_text_fallback', { text: pendingSay });
          transcript.system(L.liveFallback || 'Her live video is unavailable right now, so Hannah will talk with you by voice.');
          session = createSession(ui, voiceOpts);
          setTimeout(function () { session.start().catch(function () {}); }, 300);
          return;
        }
        if (!isText && !Guard.left() && !userEnded) { transcript.system(L.endedNote || 'Call ended. Tap the button to talk again - she remembers where you left off.'); }
      },
      onError: function (m) { toast(esc(m), 6000); transcript.system(m); },
      onTool: function () {},
      onCart: function (item) { transcript.system((L.added || 'Added to your cart:') + ' ' + item.product_title); },
      showPick: showPick, showProducts: showProducts, showCollection: showCollection, showSignup: showSignup
    };
    var voiceOpts = { mode: isText ? 'text' : 'voice', agentId: S.agentId, firstMessage: S.firstMessage, language: S.language };
    var dog = Watchdog(function () { return session; }, function (why) {
      userEnded = true;
      transcript.system(why === 'time' ? (L.timeNote || 'That was a long call, so Hannah wrapped up. Tap the button to talk again.') : (L.silenceNote || 'Hannah hung up after a quiet moment. Tap the button whenever you want to talk again.'));
    });
    var session = useAnam ? createAnamSession(ui, { video: liveVideo }) : createSession(ui, voiceOpts);
    function startVoice() {
      if (!Guard.check()) { pendingSay = null; return Promise.resolve(); }
      Log.event('start_click', { mode: 'voice', engine: session.engine || 'elevenlabs' });
      return session.start().catch(function (e) {
        if (session.engine !== 'anam') { pendingSay = null; return; }
        if (e && e.status === 429) { pendingSay = null; transcript.system(e.message); return; }
        /* the live face could not start: carry on by voice so the customer is never stuck */
        log('live avatar failed, falling back to voice', e);
        transcript.system(L.liveFallback || 'Her live video is unavailable right now, so Hannah will talk with you by voice.');
        session = createSession(ui, voiceOpts);
        return session.start().catch(function () { pendingSay = null; });
      });
    }
    btnStart.onclick = function () { startVoice(); };
    btnEnd.onclick = function () { userEnded = true; pendingSay = null; session.end('user'); };
    btnMute.onclick = function () { session.setMuted(!session.muted()); };

    function setCaption(text, isUser) {
      clearTimeout(captionTimer);
      caption.textContent = text; caption.classList.toggle('hannah-caption--user', !!isUser);
      if (isUser) { captionTimer = setTimeout(function () { if (caption.classList.contains('hannah-caption--user')) { caption.textContent = ''; } }, 5000); }
    }

    /* ---- recommendations ---- */
    /* When she shows something below or beside her that is out of sight: scroll to it, let the
       customer see it for a few seconds, then glide back to her (unless they start scrolling). */
    var revealTimer = null, returnTimer = null, touched = false;
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, function () { touched = true; }, { passive: true }); });
    function reveal(target) {
      var mode = S.reveal || 'show_return'; if (mode === 'off' || !target) { return; }
      clearTimeout(revealTimer);
      revealTimer = setTimeout(function () {
        var r = target.getBoundingClientRect(), vh = window.innerHeight || 800;
        if (r.top >= 0 && r.top < vh * .75 && r.height > 0) { return; } /* already in view */
        touched = false;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        Log.event('reveal', { mode: mode });
        if (mode !== 'show_return') { return; }
        clearTimeout(returnTimer);
        returnTimer = setTimeout(function () {
          if (touched) { return; } /* they are reading or scrolling: leave them there */
          var back = isText ? composer : scene;
          back.scrollIntoView({ behavior: 'smooth', block: isText ? 'end' : 'center' });
        }, (S.revealSeconds || 4) * 1000 + 700);
      }, 700); /* waits for a combo to finish arriving */
    }

    var turnPicks = [];
    function showPick(f, reason, o) {
      o = o || {};
      var combo = o.source === 'agent' && turnPicks.length > 0;
      if (combo && turnPicks.indexOf(f.handle) > -1) { return; }
      if (!combo) { turnPicks = []; }
      turnPicks.push(f.handle);
      var card = productCard(f, 'featured', { reason: reason, tag: o.tag || null, newTab: true });
      if (combo) {
        /* she is putting a combo together: keep the earlier item(s) and add this one */
        var list = $('.h-picks', slots.pick);
        if (list) { list.appendChild(card); }
        var h = $('.h-side-title h3', slots.pick); if (h) { h.textContent = L.picksTitle || 'Her picks for you'; }
        if (isText) { transcript.attach(productCard(f, 'mini', {})); }
        Log.event('combo_item', { handle: f.handle, items: turnPicks.length });
        reveal(slots.pick);
        return;
      }
      currentPick = f;
      slots.pick.innerHTML = '';
      slots.pick.appendChild(sideBlock(o.title || L.pickTitle || 'Her pick for you', el('div', { class: 'h-picks' }, [card])));
      root.classList.add('has-pick');
      bubbles.set(Memory.picks(), f.handle); bubbles.set(Memory.picks().filter(function (p) { return p.handle !== f.handle; }));
      if (isText) { transcript.attach(productCard(f, 'mini', {})); }
      loadRelated(f, S.relatedCount).then(function (list) {
        slots.related.innerHTML = '';
        if (!list.length) { return; }
        var grid = el('div', { class: 'h-grid', style: '--h-cols:' + (S.relatedCount >= 8 ? 4 : 3) }, list.map(function (p) { return productCard(p, 'small', { newTab: true }); }));
        slots.related.appendChild(sideBlock(L.relatedTitle || 'More like this', grid));
      });
      if (S.collectionsCount > 0) {
        relatedCollections(f, S.collectionsCount).then(function (cols) {
          if (currentPick !== f) { return; }
          collectionsBlock(slots.collections, cols, L.collectionsTitle || 'Collections you’ll like', S.collectionStyle);
        });
      }
      if (o.source !== 'memory') { reveal(slots.pick); }
    }
    function showProducts(list, title) {
      slots.alts.innerHTML = '';
      if (!list.length) { return; }
      root.classList.add('has-pick');
      slots.alts.appendChild(sideBlock(title || L.altsTitle || 'A few options', el('div', { class: 'h-grid', style: '--h-cols:' + (list.length > 4 ? 3 : 2) }, list.map(function (p) { return productCard(p, 'small', { newTab: true }); }))));
      if (isText) { list.slice(0, 4).forEach(function (p) { transcript.attach(productCard(p, 'mini', {})); }); }
      reveal(slots.alts);
    }
    function showCollection(c) {
      slots.alts.innerHTML = '';
      root.classList.add('has-pick');
      var grid = el('div', { class: 'h-grid', style: '--h-cols:3' }, (c.products || []).slice(0, 6).map(function (p) { return productCard(p, 'small', { newTab: true }); }));
      slots.alts.appendChild(sideBlock(c.title, el('div', {}, [collectionCard(c), el('div', { style: 'height:10px' }), grid]), el('a', { href: c.url, text: tx('seeAll', 'See all') + ' ' + (c.count || '') })));
      reveal(slots.alts);
    }
    function showSignup() {
      slots.signup.innerHTML = ''; root.classList.add('has-pick');
      slots.signup.appendChild(signupCard());
      if (isText) { transcript.attach(signupCard()); }
      reveal(slots.signup);
    }
    function reopen(handle, why) {
      Catalog.product(handle).then(function (f) {
        showPick(f, why, { source: 'memory', tag: L.memoryTag || 'Earlier pick' });
        Log.event('pick_reopened', { handle: handle });
        session.context('The customer just re-opened an earlier recommendation on screen: ' + f.title + ' (' + f.handle + ', ' + money(f.price) + '). Mention it naturally if relevant.');
      }).catch(function () { toast(esc(tx('unavailable', 'That product is no longer available.'))); });
    }

    /* ---- audio level loop ---- */
    (function loop() {
      if (destroyed) { return; }
      raf = requestAnimationFrame(loop);
      if (!session.isOpen()) { root.style.setProperty('--h-level', 0); return; }
      root.style.setProperty('--h-level', clamp(session.outVol() * 1.6, 0, 1).toFixed(3));
      var inv = session.inVol(); if (inv > .08) { dog.activity(); }
      root.style.setProperty('--h-in', clamp(inv * 2, 0, 1).toFixed(3));
    })();

    /* ---- deep links: ?pick=handle  ?say=hello ---- */
    var qs = new URLSearchParams(location.search);
    if (qs.get('pick')) { reopen(qs.get('pick'), L.fromMemory || 'From an earlier chat'); }
    if (isText && qs.get('say')) { setTimeout(function () { input.value = qs.get('say'); composer.dispatchEvent(new Event('submit', { cancelable: true })); }, 400); }
    if (isText && !CFG.designMode && S.autostart) { session.start().catch(function () {}); }
    applyPrefs();
    if (S.collectionsCount > 0 && !qs.get('pick')) {
      var lastPick = Memory.picks()[0];
      var needStore = RULE.mode === 'exclude' && !(CFG.knownCollections || []).length;
      var opening = (needStore ? loadStoreCollections() : Promise.resolve()).then(function () { return lastPick
        ? relatedCollections({ title: lastPick.title, vendor: lastPick.vendor, type: '', tags: [], collections: [] }, S.collectionsCount)
        : randomCollections(S.collectionsCount); });
      opening.then(function (cols) {
        if (currentPick || !cols.length) { return; }
        collectionsBlock(slots.collections, cols, lastPick ? (L.collectionsTitle || 'Collections you’ll like') : (L.exploreTitle || 'Collections to explore'), S.collectionStyle);
        root.classList.add('has-pick');
      });
    }
    if (!isText && !Memory.picks().length) { transcript.system(L.firstVisit || 'First time? Tap the button, allow the microphone, and just say hello.'); }
    Log.event('stage_view', { mode: S.mode, picks: Memory.picks().length });

    var api = { session: session, showPick: showPick, destroy: function () { destroyed = true; cancelAnimationFrame(raf); session.end('unload'); galaxy && galaxy.destroy(); bubbles.destroy(); wave && wave.destroy(); root.__hannah = null; } };
    root.__hannah = api; return api;
  }

  /* ============================================================ COMPACT */
  function initCompact(root) {
    if (root.__hannah) { return root.__hannah; }
    var S = readSettings(root); var L = S.labels || {};
    var launch = $('[data-launch]', root), body = $('[data-body]', root), hello = $('[data-hello]', root);
    var slotPick = $('[data-slot="pick"]', root), transcriptEl = $('[data-transcript]', root), foot = $('[data-foot]', root), tools = $('[data-tools]', root), face = $('[data-face]', root), statusTxt = $('[data-status-text]', root), dot = $('.h-dot', root);
    if (dot && Guard.left()) { dot.classList.add('is-blocked'); }
    var kind = Memory.pref('compactKind') || S.defaultMode || 'text';
    if (S.voice === false) { kind = 'text'; }
    var transcript = Transcript(transcriptEl, { scroller: body }), galaxy = null, wave = null, raf = 0, destroyed = false, session = null, open = false;
    if (slotPick) { slotPick.hidden = true; }
    if (S.galaxy !== false) { galaxy = Galaxy($('[data-galaxy]', root), { stars: 55, speed: .8, accent: cssVar(root, '--h-accent', S.accent), ink: cssVar(root, '--h-text', '#1c1d1d'), lines: true }); }

    /* launcher phrases rotate while the panel is closed */
    var phrases = (S.phrases || []).filter(Boolean); var pi = 0, sub = $('[data-launch-sub]', root);
    if (sub && phrases.length > 1) { setInterval(function () { if (open || document.hidden) { return; } pi = (pi + 1) % phrases.length; sub.style.opacity = 0; setTimeout(function () { sub.textContent = phrases[pi]; sub.style.opacity = 1; }, 250); }, (S.phraseSeconds || 4) * 1000); }

    /* header tools */
    var btnKind = el('button', { class: 'h-btn h-btn--icon', type: 'button', html: icon('mic'), hidden: S.voice === false });
    var btnMem = el('button', { class: 'h-btn h-btn--icon', type: 'button', title: L.memory || 'Past picks', 'aria-label': L.memory || 'Past picks', html: icon('clock') });
    var btnExpand = el('a', { class: 'h-btn h-btn--icon', title: L.expand || 'Open the full page', 'aria-label': L.expand || 'Open the full page', html: icon('expand'), href: '#' });
    var btnClose = el('button', { class: 'h-btn h-btn--icon', type: 'button', title: 'Close', 'aria-label': 'Close', html: icon('close'), hidden: S.display === 'inline' });
    [btnKind, btnMem, btnExpand, btnClose].forEach(function (b) { tools.appendChild(b); });

    /* footer: voice row + composer */
    var voiceRow = el('div', { class: 'hannah-panel__voice' });
    var btnTalk = el('button', { class: 'h-btn h-btn--icon h-talk', type: 'button', title: L.start || 'Talk', 'aria-label': L.start || 'Talk', html: icon('mic') });
    var waveCanvas = el('canvas', { 'aria-hidden': 'true' });
    var btnMute = el('button', { class: 'h-btn h-btn--icon', type: 'button', title: L.mute || 'Mute', 'aria-label': L.mute || 'Mute', html: icon('mic'), hidden: true });
    var btnHang = el('button', { class: 'h-btn h-btn--icon h-btn--danger', type: 'button', title: L.end || 'End', 'aria-label': L.end || 'End', html: icon('phoneOff'), hidden: true });
    [btnTalk, waveCanvas, btnMute, btnHang].forEach(function (b) { voiceRow.appendChild(b); });
    var input = el('input', { type: 'text', placeholder: L.placeholder || 'Ask Hannah anything about cigars…', autocomplete: 'off', 'aria-label': 'Message' });
    var composer = el('form', { class: 'hannah-composer' }, [input, el('button', { class: 'h-btn h-btn--icon h-send', type: 'submit', 'aria-label': L.send || 'Send', html: icon('send') })]);
    var note = el('p', { class: 'hannah-panel__note', text: CFG.disclaimer || '' });
    foot.appendChild(voiceRow); foot.appendChild(composer); foot.appendChild(note);

    /* what the agent (or the memory sheet) paints into the panel */
    var turnPicks = [], relatedRow = null;
    function showPick(f, reason, o) {
      o = o || {};
      hello.hidden = true;
      if (turnPicks.indexOf(f.handle) > -1) { return; }
      turnPicks.push(f.handle);
      transcript.attach(productCard(f, 'pick', { reason: reason, tag: o.tag || (turnPicks.length > 1 ? (L.alsoTag || 'Also') : (L.pickTag || 'Her pick')) }), { stack: true });
      /* "more like this" only under the first pick of her answer, so a combo stays tidy */
      if (turnPicks.length > 1 && relatedRow && relatedRow.__turn === turnPicks) { relatedRow.remove(); relatedRow = null; }
      if (S.related > 0 && turnPicks.length === 1) {
        var mine = turnPicks;
        loadRelated(f, S.related).then(function (list) {
          /* wait a moment: if she adds more items (a combo), skip it */
          setTimeout(function () {
            if (!list.length || turnPicks !== mine || turnPicks.length !== 1) { return; }
            var row = el('div', { class: 'h-carousel' }, list.map(function (p) { return productCard(p, 'small', {}); }));
            relatedRow = el('div', { class: 'h-carousel-wrap' }, [el('div', { class: 'h-carousel__title', text: L.relatedTitle || 'More like this' }), row]);
            relatedRow.__turn = mine;
            transcript.attach(relatedRow, { stack: true });
          }, 1500);
        });
      }
    }
    function showProducts(list) { hello.hidden = true; list.slice(0, 6).forEach(function (p) { transcript.attach(productCard(p, 'mini', {}), { stack: true }); }); }
    function showCollection(c) { hello.hidden = true; transcript.attach(collectionCard(c)); (c.products || []).slice(0, 3).forEach(function (p) { transcript.attach(productCard(p, 'mini', {})); }); }
    function showSignup() { hello.hidden = true; transcript.attach(signupCard()); }

    function makeSession(k) {
      var ui = {
        onStatus: function (s) {
          dot.setAttribute('data-status', s);
          statusTxt.textContent = { connecting: L.connecting || 'Connecting…', connected: k === 'voice' ? (L.listening || 'Listening') : (L.online || 'Online'), disconnected: L.idle || 'AI concierge', disconnecting: '…' }[s] || s;
          var live = s === 'connected' || s === 'connecting';
          btnTalk.hidden = live; btnHang.hidden = !live; btnMute.hidden = !live;
          if (live) { hello.hidden = true; }
          if (s === 'connected' && k === 'voice') { dogC.start(); }
        },
        onMode: function (m) { dogC.activity(); dot.setAttribute('data-mode', m); face.classList.toggle('is-speaking', m === 'speaking'); if (k === 'voice') { statusTxt.textContent = m === 'speaking' ? (L.speaking || 'Speaking') : (L.listening || 'Listening'); } },
        onMute: function (m) { btnMute.innerHTML = m ? icon('micOff') : icon('mic'); btnMute.classList.toggle('is-on', m); },
        onMessage: function (role, text) { hello.hidden = true; if (role === 'user') { dogC.activity(); turnPicks = []; transcript.user(text); } else { transcript.agentFinal(text); } },
        onPart: function (p) { if (k !== 'text') { return; } hello.hidden = true; if (p.type === 'start') { transcript.agentStart(); } else if (p.type === 'delta' || (!p.type && p.text)) { transcript.agentDelta(p.text || ''); } },
        onEnd: function () { face.classList.remove('is-speaking'); dogC.stop(); if (k === 'voice') { transcript.system(L.endedNote || 'Call ended. Tap the mic to talk again.'); } },
        onHangUp: function (reason) { if (reason === 'off_topic' || reason === 'abuse') { setTimeout(function () { transcript.system(Guard.opts().msg); }, 1500); } },
        onError: function (m) { transcript.system(m); },
        onCart: function (item) { transcript.system((L.added || 'Added to your cart:') + ' ' + item.product_title); },
        showPick: showPick, showProducts: showProducts, showCollection: showCollection, showSignup: showSignup
      };
      return createSession(ui, { mode: k === 'voice' ? 'voice' : 'text', agentId: S.agentId, firstMessage: S.firstMessage, language: S.language });
    }
    function setKind(k) {
      kind = k; Memory.pref('compactKind', k);
      btnKind.innerHTML = k === 'voice' ? icon('keyboard') : icon('mic');
      var kindLabel = k === 'voice' ? (L.toText || 'Switch to typing') : (L.toVoice || 'Switch to voice');
      btnKind.title = kindLabel; btnKind.setAttribute('aria-label', kindLabel);
      voiceRow.hidden = k !== 'voice';
      note.textContent = k === 'voice' ? [CFG.disclaimer, CFG.micNote].filter(Boolean).join(' ') : (CFG.disclaimer || '');
      btnExpand.href = (k === 'voice' ? (CFG.urls && CFG.urls.face) : (CFG.urls && CFG.urls.chat)) || '#';
      if (!session || session.kind !== k) { var old = session; session = makeSession(k); if (old) { old.end('switch'); } }
      root.setAttribute('data-kind', k);
    }
    function reopen(handle) {
      Catalog.product(handle).then(function (f) {
        turnPicks = [];
        showPick(f, L.fromMemory || 'From an earlier chat', { tag: L.memoryTag || 'Earlier pick' });
        Log.event('pick_reopened', { handle: handle, where: 'compact' });
        session.context('The customer re-opened an earlier recommendation: ' + f.title + ' (' + f.handle + ').');
      }).catch(function () { toast(esc(tx('unavailable', 'That product is no longer available.'))); });
    }
    btnKind.onclick = function () { setKind(kind === 'voice' ? 'text' : 'voice'); };
    btnMem.onclick = function () { openMemorySheet(function (pk) { reopen(pk.handle); }); };
    var dogC = Watchdog(function () { return session; }, function () { transcript.system(L.endedNote || 'Call ended. Tap the mic to talk again.'); });
    btnTalk.onclick = function () { if (!Guard.check()) { return; } Log.event('start_click', { mode: 'voice', where: 'compact' }); session.start().catch(function () {}); };
    btnHang.onclick = function () { session.end('user'); };
    btnMute.onclick = function () { session.setMuted(!session.muted()); };
    composer.addEventListener('submit', function (e) { e.preventDefault(); var t = input.value.trim(); if (!t) { return; } if (!session.isOpen() && !Guard.check()) { return; } input.value = ''; hello.hidden = true; turnPicks = []; if (!session.isOpen()) { transcript.user(t); } session.send(t).catch(function () {}); });
    input.addEventListener('input', function () { session.activity(); });
    $$('[data-quick] button', root).forEach(function (b) { b.addEventListener('click', function () { var t = b.getAttribute('data-say') || b.textContent; if (!session.isOpen() && !Guard.check()) { return; } hello.hidden = true; turnPicks = []; if (!session.isOpen()) { transcript.user(t); } session.send(t).catch(function () {}); }); });

    function setOpen(o) {
      open = o; root.classList.toggle('is-open', o);
      if (o) {
        Log.event('compact_open', { kind: kind });
        if (!wave) { wave = Wave(waveCanvas, function () { return session.outFreq(); }, function () { return session.outVol(); }, S.accent || '#e3b261'); }
        if (kind === 'text' && !isPhone()) { setTimeout(function () { input.focus(); }, 200); }
      } else { session && session.end('close'); }
    }
    if (launch) { launch.onclick = function () { setOpen(true); }; }
    btnClose.onclick = function () { setOpen(false); Memory.pref('compactDismissed', true); };
    if (S.display === 'inline') { setOpen(true); }
    else if (S.autoOpen > 0 && !Memory.pref('compactDismissed') && !CFG.designMode) { setTimeout(function () { if (!open) { setOpen(true); } }, S.autoOpen * 1000); }

    (function loop() { if (destroyed) { return; } raf = requestAnimationFrame(loop); if (session && session.isOpen() && session.inVol() > .08) { dogC.activity(); } root.style.setProperty('--h-level', session && session.isOpen() ? clamp(session.outVol() * 1.6, 0, 1).toFixed(3) : 0); })();
    setKind(kind);
    var api = { showPick: showPick, open: function () { setOpen(true); }, close: function () { setOpen(false); }, session: function () { return session; }, destroy: function () { destroyed = true; cancelAnimationFrame(raf); session && session.end('unload'); galaxy && galaxy.destroy(); wave && wave.destroy(); root.__hannah = null; } };
    root.__hannah = api; return api;
  }

  /* ============================================================ bootstrap */
  function initAll(scope) {
    $$('[data-hannah-stage]', scope).forEach(function (r) { try { initStage(r); } catch (e) { log('stage init failed', e); if (DEBUG) { throw e; } } });
    $$('[data-hannah-compact]', scope).forEach(function (r) { try { initCompact(r); } catch (e) { log('compact init failed', e); if (DEBUG) { throw e; } } });
  }
  H.init = initAll; H.initStage = initStage; H.initCompact = initCompact;
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(document); }); } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { $$('[data-hannah-stage],[data-hannah-compact]', e.target).forEach(function (r) { if (r.__hannah) { r.__hannah.destroy(); } }); });
  window.addEventListener('pagehide', function () { $$('[data-hannah-stage],[data-hannah-compact]').forEach(function (r) { if (r.__hannah && r.__hannah.destroy) { try { r.__hannah.destroy(); } catch (e) {} } }); });
})();
